const TRANSLATION_EN = {
    "No alerts for this period": "No alerts for this period",
    "Unable to load alerts for this class": "Unable to load alerts for this class",

    "Select which classes to include in the year analytics view.": "Select which classes to include in the year analytics view.",
    "See less classes": "See less classes",
    "See all classes": "See all classes",

    // Filtered analytics student summary
    "studentCountLabel_one": "{{total}} student",
    "studentCountLabel_other": "{{total}} students",
    "Students included": "Students included",
    "checked in during this period": "checked in during this period",
    "Students who checked in": "Students who checked in",
    "{{percentage}}% of included students · {{count}} haven't checked in": "{{percentage}}% of included students · {{count}} haven't checked in",
    "All accessible students": "All accessible students",
    "Selected student groups": "Selected student groups",
    "Unable to load student count": "Unable to load student count",
    "Based on {{checkIns}} check-ins from {{checkedIn}} of {{included}} included students": "Based on {{checkIns}} check-ins from {{checkedIn}} of {{included}} included students",

    // Year-group analytics
    "Year analytics": "Year analytics",
    "Search for years": "Search for years",
    "We found {{total}} year(s)": "We found {{total}} year(s)",
    "Year {{year}} analytics": "Year {{year}} analytics",
    "Change year": "Change year",
    "Year emotional breakdown": "Year emotional breakdown",
    "Year total": "Year total",
    "Wellbeing comparison for selected classes": "Wellbeing comparison for selected classes",
    "Alerts for selected classes": "Alerts for selected classes",
    "Compared with year average": "Compared with year average",
    "percentage points": "percentage points",
    "No matching years": "No matching years",
    "No year groups assigned": "No year groups assigned",
    "Select at least one class to view analytics": "Select at least one class to view analytics",
    "You do not have access to this year": "You do not have access to this year",
    "You do not have access to year analytics": "You do not have access to year analytics",
    "Those classes are outside the selected year": "Those classes are outside the selected year",
    "Unable to load year analytics": "Unable to load year analytics",
    "Unable to load analytics search": "Unable to load analytics search",
    "Check-ins overview for selected classes": "Check-ins overview for selected classes",
    "Emotional trends for selected classes": "Emotional trends for selected classes",
    "Unresolved alerts for this year during the selected period.": "Unresolved alerts for this year during the selected period.",
    "Compare classes against the full year. The year average stays fixed when classes are filtered.": "Compare classes against the full year. The year average stays fixed when classes are filtered.",
    "Assigned groups": "Assigned groups",
    "Assigned groups average": "Assigned groups average",
    "Assigned groups emotional breakdown based on {{number}} check-ins": "Assigned groups emotional breakdown based on {{number}} check-ins",
    "Use this search to explore student, class, year, or counsellor analytics and access deeper insights.": "Use this search to explore student, class, year, or counsellor analytics and access deeper insights.",

    confirmDeletion: 'Confirm deletion',
    deleteTheTemplateFor: 'Delete the template for',
    cancel: 'Cancel',
    delete: 'Delete',
    createContent: 'Create content',
    askAQuestion: 'Ask a question',
    createAPoll: 'Create a poll',
    createAPost: 'Create a post',
    orChooseFromTemplatesBelow: 'or choose from templates below',
    on: 'On',
    off: 'Off',
    never: 'Never',
    chooseTemplate: 'Choose template',
    thereAreNoTemplatesCreated: 'There are no templates created',
    howAreYouToday: 'How are you today?',
    selectEmotion: 'Select emotion',
    question: 'Question',
    genderSelection: 'Gender selection',
    all: 'All',
    male: 'Male',
    female: 'Female',
    settings: 'Settings',
    support: 'Support',
    privacyPolicy: 'Privacy policy',
    about: 'About',
    dayReview: 'Day review',
    dailyReflection: 'Daily reflection',
    youLiked: 'You liked',
    like: 'Like',
    edit: 'Edit',
    answered: 'Answered',
    showLess: 'Show Less',
    showMore: 'Show More',
    search: 'Search',
    targetGroup: 'Target group',
    quickAction: 'Quick action',
    select: 'Select',
    selectByGroup: 'Select by group',
    selectSchoolYearsThatYouLikeToTarget: 'Select school years that you like to target',
    years: 'years',
    Years: 'Years',
    year: 'year',
    Year: 'Year',
    selectClassesThatYouLikeToTarget: 'Select classes that you like to target',
    classes: 'Classes',
    class: 'Class',
    selectACustomListThatYouLikeToTarget: 'Select a custom list that you like to target',
    custom: 'Custom',
    selectTeachersYouWouldLikeToTarget: 'Select teachers you would like to target',
    staff: 'Staff',
    selectYears: 'Select years',
    selectClasses: 'Select classes',
    selectFromMyStudents: 'Select from my students',
    multipleClasses: 'Multiple Classes',
    multipleYears: 'Multiple years',
    allStudents: 'All students',
    done: 'Done',
    waitForTeachersToFeedYouWithSomeNewInformations: 'Wait for teachers to feed you with some new informations',
    feedIsEmpty: 'Feed is empty',
    thereIsNoFeedForThisSearch: 'There is no feed for this search',
    createNewPostsForYourStudentsAndHereIsAShortcutForYou: 'Create new posts for your students. Here is a shortcut for you.',
    waitForTeacherToFeedYouWithSomeNewInformation: 'Wait for teacher to feed you with some new information',
    createFeedPost: 'Create feed post',
    targetList: 'Target list',
    beAmazing: 'Be amazing!',
    login: 'Login',
    getStarted: 'Get started',
    enterYourSchoolEmail: 'Enter your school email',
    password: 'Password',
    email: 'Email',
    requestNewPassword: 'Request new password',
    newPassword: 'New password',
    enterYourSchoolEmailAndWeWillSendYouALinkToGetBackIntoYourAccount: "Enter your school email and we'll send you a validation token to get back into your account",
    sendRequest: 'Send request',
    verifyYourEmail: 'Verify your email',
    weHaveSentYouALinkToGetBackIntoYourAccountAndCheckYourMailAndCopyYourTokenHere:
        "We've sent you a validation token to get back into your account. Check your mail and copy your token here.",
    resendARequest: 'Resend a request',
    didntGetAMail: "Didn't get a mail?",
    submit: 'Submit',
    enterYourNewPassword: 'Enter your new password',
    apply: 'Apply',
    howDoYouFeel: 'How do you feel?',
    'How do you feel?': 'How do you feel?',
    poll: 'Poll',
    thereAreNoAnswersOrFeedbacksForThisDay: 'There are no answers or feedbacks for this day',
    title: 'Title',
    message: 'Message',
    requested: 'Requested',
    anonymous: 'Anonymous',
    url: 'Url',
    addPhoto: 'Add Photo',
    removePhoto: 'Remove Photo',
    youAreAllDone: 'You are all done!',
    congratsEverythingIsDoneForNowWaitForNewTasks: 'Congrats, everything is done for now! Wait for new tasks...',
    excellentWorkWeAreDelightedToHearThingsAreSoMuchBetter: 'Excellent work! We’re delighted to hear things are so much better.',
    thisIsYourSafePlaceAndNothingWillBeShared: 'This is your safe place. Nothing will be shared.',
    enterANameForTodaysNotes: "Enter a name for today's notes.",
    iDontWantToSaveNotes: 'I don’t want to save notes',
    worse: 'Worse',
    sorryToHearThatThingsAreWorseWhichOfTheFollowingWouldHelpRightNow: 'Sorry to hear that things are worse. Which of the following would help right now?',
    muchWorse: 'Much worse',
    sorryToHearThatThingsAreMuchWorseAndWhichOfTheFollowingWouldHelpRightNow: 'Sorry to hear that things are much worse. Which of the following would help right now?',
    same: 'Same',
    whatAreSomeIdeasToMakeThingsBetter: 'What are some ideas to make things better?',
    better: 'Better',
    goodToHearThingsAreBetterAndWhatAreSomeIdeasToTakeItEvenFurther: 'Good to hear things are better. What are some ideas to take it even further?',
    muchBetter: 'Much better',
    greatToHearThingsAreMuchBetterAndThinkAboutHowToImproveEvenMoreOrKeepItOnAPositiveLevel:
        'Great to hear things are much better. Think about how to improve even more or keep it on a positive level',
    suggestions: 'Suggestions',
    ImOkWithIt: 'I’m Ok with it',
    ok: 'OK',
    IdPreferIfTheyWereBetter: 'I’d prefer if they were better',
    loadMoreSuggestions: 'Load more suggestions',
    continue: 'Continue',
    deleteNote: 'DELETE NOTE',
    today: 'Today',
    comparedToLastTimeTodayIamFeeling: "Compared to last time, today I'm feeling",
    howDoYouFeelComparedToLastTimeYouDidThePoll: 'How do you feel compared to last time you did the poll?',
    thisInformationWillBeSharedWith: 'This information will be shared with teacher.',
    feelFreeToShareAnyThoughtsHereWhyYouFeelThisWay: 'Feel free to share any thoughts here why you feel this way',
    feedback: 'Feedback',
    choose: 'Choose',
    newFeeds: 'New feeds',
    openTasks: 'Open Tasks',
    taskArchive: 'Task Archive',
    congratsAndEverythingIsDoneForNowAndWaitForNewTasksFromYourTeacher: 'Congrats, everything is done for now! Wait for new tasks from your teacher',
    newConversation: 'New conversation',
    teacher: 'Teacher',
    teachers: 'Teachers',
    counselor: 'Counsellor',
    secretKey: 'Secret key',
    advancedSettings: 'Advanced settings',
    showDailyReflectionScreen: 'Show daily reflection screen',
    termsAndConditions: 'Terms & Conditions',
    appVersion: 'App version: ',
    surname: 'Surname',
    firstName: 'First name',
    gender: 'Gender',
    other: 'Other',
    thisIsYourSafePlace: 'This is your safe place',
    thisIsYourPrivateRoom: 'This is your private room.',
    safePlaceWithDailyReflectionNotes: 'Safe place with daily reflection notes',
    personalInformation: 'Personal information',
    privacyAndSecurity: 'Privacy and security',
    dashboard: 'Dashboard',
    update: 'Update',
    unselect: 'Unselect',
    noResults: 'No results',
    open: 'Open',
    share: 'Share',
    back: 'Back',
    backToRoleSelection: 'Back to Role Selection',
    task: 'Task',
    tasks: 'Tasks',
    logout: 'Logout',
    save: 'Save',
    name: 'Name',
    profile: 'Profile',
    classroom: 'Classroom',
    feed: 'Feed',
    live: 'Live',
    archive: 'Archive',
    yesterday: 'Yesterday',
    tomorrow: 'Tomorrow',
    results: 'Results',
    required: 'Required',
    schedule: 'Schedule',
    happy: 'happy',
    excited: 'excited',
    ecstatic: 'ecstatic',
    inspired: 'inspired',
    calm: 'calm',
    lethargic: 'lethargic',
    grumpy: 'grumpy',
    sad: 'sad',
    stressed: 'stressed',
    angry: 'angry',
    sunday: 'Sunday',
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    saturday: 'Saturday',
    scheduled: 'Scheduled',
    delivered: 'Delivered',
    first: 'First',
    second: 'Second',
    third: 'Third',
    seen: 'Seen',
    selectStaff: 'Select staff',
    forgotPassword: 'Forgot password?',
    repeatPassword: 'Repeat password',
    retypePassword: 'Retype password',
    changePassword: 'Change password',
    hidePassword: 'Hide password',
    dailyFeedback: 'Daily Feedback',
    createNew: 'Create new',
    selectionType: 'Selection type',
    enterSurname: 'Enter surname',
    enterEmail: 'Enter email',
    newMessage: 'New message!',
    myTasks: 'My Tasks',
    addOption: 'Add option',
    newQuestion: 'New Question',
    editQuestion: 'Edit Question',
    editPost: 'Edit post',
    editPoll: 'Edit poll',
    editGroup: 'Edit Group',
    tomorrowPlans: 'Tomorrow plans',
    confirmStopping: 'Confirm stopping',
    newPoll: 'New poll',
    answer: 'Answer',
    post: 'Post',
    hi: 'Hi',
    stop: 'Stop',
    lastTime: 'Last time',
    sendAnswer: 'Send answer',
    comment: 'Comment',
    passwordMustBeLongerThan8CharactersAndMustContainsUppercaseLowercaseNumberAndSpecialSymbol:
        'Your password must be at least 8 characters long and include an uppercase letter, a lowercase letter, a number, and a special symbol.',
    enterYourWorkEmailAndPassword: 'Enter your work email and password',
    submitNewPassword: 'Submit new password',
    pleaseCheckYourMailToConfirmYourEmailAddress: 'Please check your mail to confirm your email address!',
    howDoYouFeelAboutThingsBeingTheSameToday: 'How do you feel about things being the same today?',
    pollHasBeenUpdated: 'Poll has been updated',
    typeAPostTitle: 'Type a post title',
    addAnOptionalMessage: 'Add an optional message',
    writeYourMessageHere: 'Write your message here',
    enterUrlLink: 'Enter url link',
    saveAndContinue: 'Save and continue',
    nameOfTodayNote: 'Name of today note',
    whatAreJust3GoodThingsThatHappenedToday: 'What are just 3 good things that happened today?',
    yourDirectManager: 'your direct manager',
    secretKeyHasBeenSaved: 'Secret key has been saved',
    enterYourSecretKeyToEncryptLllYourMessagesAndAnswers: 'Enter your secret key to encrypt all your messages and answers',
    enterSecretKey: 'Enter your secret key',
    locked: 'Locked',
    thisNoteIsEncryptedEnterYourSecretKeyToReadIt: 'This note is encrypted. Enter your secret key to read it.',
    unlockYourNotes: 'Unlock your notes',
    enterTheSecretKeyYouUsedForTheseNotes: 'Enter the secret key you used for these notes. Keys you have already entered stay unlocked.',
    thatKeyDidNotUnlockAnyNotes: "That key didn't unlock any notes. Check it and try again.",
    advancedSettingsAreSuccessfullySaved: 'Advanced settings are successfully saved!',
    youCanUseTheButtonsAboveToContactYourTeacherOrCounselorForSupportAtAnyPoint: 'You can use the buttons above to contact your teacher or counsellor for support at any point',
    waitForStudentsToContactYouToHelpThem: 'Wait for students to contact you to help them',
    passwordsDoNotMatch: 'Passwords do not match',
    startNewChat: 'Start new chat',
    shareWithTeacher: 'Share with teacher',
    tasksForThisSection: 'Tasks for this section',
    howWasYourDay: 'How was your day?',
    thisIsAutoReplyMessage: 'This is auto reply message',
    thankYouForReachingOutWeWillReplyToYourMessageSoonIfYouOrSomeoneYouKnowIsInImmediateDangerPleaseCallEmergencyServices:
        'Thank you for reaching out. We will reply to your message soon.',
    doYouThinkThingsAreForAnyReasonInParticular: 'Do you think things are {{result}} for any reason in particular?',
    yourPrivateNotes: 'Your private notes',
    createNewPoll: 'Create new poll',
    saveAsTemplate: 'Save as template',
    addPostContentHere: 'Add post content here',
    typeAPollQuestion: 'Type a poll question ...',
    questionHasBeenUpdated: 'Question has been updated',
    questionHasBeenPosted: 'Question has been posted',
    iDontWantToThinkAboutThisNow: "I don't want to think about this now",
    selectLanguage: 'Select language',
    userIsUpdated: 'User is updated',
    imageIsNotUploaded: 'Image is not uploaded',
    feedHasBeenUpdated: 'Feed has been updated',
    permissionIsNotAccepted: 'Permission is not accepted',
    feedHasBeenPosted: 'Feed has been posted',
    pollHasBeenPosted: 'Poll has been posted',
    templateHasBeenSaved: 'Template has been saved',
    privateNoteHasBeenSaved: 'Private note has been saved',
    yourEmotionHasBeenShared: 'Your emotion has been shared',
    compareToLastTime: 'Compare to last time',
    yourAnswerIsSaved: 'Your answer is saved',
    staySecuredFirst: 'Stay secured first',
    day: 'Day',
    dateOfBirth: 'Date of Birth',
    teacherInfo: 'Teacher info',
    studentInfo: 'Student info',
    manage: 'Manage',
    openListWithAllClassesFromThisSchool: 'Open list with all classes from this school',
    wizardToCreateNewClassAddStudentsAndHeaTteacher: 'Wizard to create new class, add students and head teacher',
    openListWithAllTeachersThatGoToThisSchool: 'Open list with all teachers that go to this school',
    wizardToCreateNewTeacherAndLinkItToProperClass: 'Wizard to create new teacher and link it to proper class',
    chooseDataRange: 'Choose data range',
    thisListRepresentsAllContentFromThisTypeYouCanEditOrDeleteTt: 'This list represents all content from this type. You can edit or delete it',
    lastCreatedpoll: 'Last created poll',
    lastCreatedfeed: 'Last created feed',
    lastCreatedquestion: 'Last created question',
    listOfDays: 'List of days',
    selectThisquestion: 'Select this question',
    selectThispoll: 'Select this poll',
    selectThisfeed: 'Select this feed',
    createOwn: 'Create own',
    showAllContent: 'Show all content',
    programDuration: 'Program duration',
    seeThisProgram: 'See this program',
    programs: 'Programs',
    hereYouCanCreateAPollToLearnMoreAboutYourStudents: 'Here you can create a poll to learn more about your students',
    askAnOpenQuestionToGetDetailedFeedback: 'Ask an open question to get detailed feedback',
    classManagement: 'Class management',
    teacherManagement: 'Teacher management',
    inactivity: 'Inactivity',
    new: 'New',
    inactivitySettings: 'Inactivity settings',
    'Control how inactivity is measured and who gets alerted.': 'Control how inactivity is measured and who gets alerted.',
    '{{n}} never engaged': '{{n}} never engaged',
    '{{n}} recently lapsed': '{{n}} recently lapsed',
    'no check-in or response in the past {{days}} days': 'no check-in or response in the past {{days}} days',
    'No matches for': 'No matches for',
    'Last activity': 'Last activity',
    'Loading...': 'Loading...',
    analyze: 'Analyze',
    instructionVideos: 'Instruction Videos',
    created: 'Created',
    pickOneOption: 'Pick one option:',
    listOfClasses: 'List of classes',
    newClass: 'New class',
    action: 'Action',
    numberOfStudents: 'Number of students',
    listOfTeachers: 'List of teachers',
    newTeacher: 'New teacher',
    options: 'Options',
    send: 'Send',
    refresh: 'Refresh',
    selectDate: 'Select date',
    time: 'Time',
    date: 'Date',
    feedDescription: 'Here you can add text, pictures, videos or links',
    'Choose from our range of ready-to-go programs designed to support your students and save you times now':
        'Choose from our range of ready-to-go programs designed to support your students and save you times now',
    listOfStudentsWhoHaventLoggedInYet: "List of students who haven't logged in yet",
    listOfUsersWhoHaventLoggedInYet: "List of users who haven't logged in yet",
    studentsLoginData: 'Students login data',
    loadMoreClasses: 'Load more classes',
    loginInfo: 'Login info',
    role: 'Role',
    loadMore: 'Load more',
    noTeachersYet: 'No teachers yet',
    classInfo: 'Class info',
    enterClassName: 'Enter class name',
    enterSchoolYear: 'Enter school year',
    schoolYear: 'School year',
    className: 'Class name',
    listOfStudents: 'List of students',
    doYouWantToRemoveStudent: 'Do you want to remove the student?',
    doYouWantToDeleteClass: 'Do you want to delete the class?',
    emailIsInvalid: 'Email is invalid.',
    emailIsAvailable: 'Email is available!',
    emailAlreadyExists: 'Email already exists!',
    fieldIsRequired: 'Field is required',
    showPassword: 'Show password',
    enterName: 'Enter name',
    selectRole: 'Select role',
    teachersRoleNotSetYet: 'Teaching role not yet selected',
    create: 'Create',
    doYouWantToDeleteTeacher: 'Do you want to delete the teacher?',
    classIsCreated: 'The class is made!',
    reminderForToday: 'Reminder for today',
    closed: 'Closed',
    youDontHaveAnyRemindersForToday: "You don't have any reminders for today",
    firstEnterANote: 'First enter a note',
    noteIsCreated: 'Note is created',
    reminderHasBeenChanged: 'Reminder has been changed!',
    status: 'Status',
    exportReport: 'Export report',
    notes: 'Notes',
    Notes: 'Notes',
    editReminder: 'Edit reminder',
    removeReminder: 'Remove reminder',
    enterYourNoteHere: 'Enter your note here',
    createANote: 'Create a note',
    addReminder: 'Add reminder',
    teacherLogin: 'Teacher Login',
    enterCredentialsYouReceivedFromSchool: 'Enter credentials you received from school',
    received: 'Received',
    deletePost: 'Delete this post',
    doYouWantToDeletePost: 'Would you like to delete this post?',
    easilyManageYourStudentsAndTeachersWithSeparateFunctions: 'Easily manage your students and teachers with separate functions',
    user: 'User',
    userManagement: 'User management',
    chat: 'Chat',
    trackCounseling: 'Track Counseling',
    and: 'and',
    openLink: 'Open link',
    openListOfUsersWhoHaventLoggedIn: "Open list of users who haven't logged in",
    setDateForReminderOfStudent: "Set a date when you'd like to be reminded about this student",
    createReminder: 'Create reminder',
    writeFullAnswerHere: 'write the full answer here',
    answers: 'Answers',
    actionTaken: 'Action taken',
    iWillTakeAction: 'I will take action',
    seenBy: 'Seen by',
    thereAreNoAnswersForThatDay: 'No other responses from this student today',
    describeHowYouWillDealWithThisStudent: 'Describe how you will deal with this student',
    writeYourThoughtsHere: 'Write your thoughts here',
    studentData: 'Student data',
    student: 'Student',
    enterStudentUPN: 'Enter Student UPN',
    showAll: 'Show all',
    loginStatistic: 'Login Statistics',
    hereYouCanAddTextImagesVideosOrLinks: 'Here you can add text, images, videos or links',
    typeAQuestionTitle: 'Enter a Question title...',
    typeYourHeadlineHere: 'Type your headline here ...',
    optional: 'optional',
    invalidLink: 'Invalid link',
    chooseTemplateFor: 'Choose template for ',
    doYouWantToDeleteThis: 'Do you want to delete this?',
    deleteThisRunOnly: 'Delete this run only',
    deleteAllScheduledRuns: 'Delete this and all scheduled runs',
    stopThisRun: 'Stop this run only',
    stopAndRemoveScheduled: 'Stop and remove all scheduled runs',
    doYouWantToStopThis: 'Do you want to stop this?',
    scheduledRuns_one: '{{count}} scheduled run',
    scheduledRuns_other: '{{count}} scheduled runs',
    recurringContent: 'Recurring content',
    seriesDeleted: 'Content and scheduled runs deleted',
    seriesStopped: 'Content stopped and scheduled runs removed',
    yourDataIsUpdated: 'Your data is updated!',
    yourDataIsNotUpdated: 'Your data is not updated!',
    contentIsCreated: 'Content is created!',
    contentIsNotCreated: 'Content is not created!',
    templateIsCreated: 'Template is created!',
    templateIsNotCreated: 'Template is not created!',
    allCreatedContent: 'All created content',
    runProgram: 'Run program',
    teachersOnly: 'Teachers only',
    programTitle: 'Program title',
    thisToolHelpsYouPlanTheEntireProgramOnce: "This tool helps you plan the entire program once so you don't have to keep checking it.",
    startDate: 'Start date',
    selectDays: 'Select days',
    pickTime: 'Pick time',
    thisProgaramIsAlreadyRunning: 'This program is already running, run again?',
    youAreRunningThisProgramSuccessfully: 'You successfully run this program',
    surveys: 'Surveys',
    survey: 'Survey',
    description: 'Description',
    typeASurveyTitle: 'Type a survey title ...',
    addASurveyDescription: 'add a survey description',
    surveyTitle: 'Survey title',
    section: 'Section',
    sections: 'Sections',
    enterSectionTitleHere: 'Enter section title here...',
    enterSectionDescriptionHere: 'Enter section description here...',
    enterQuestionHere: 'Enter question here ...',
    openAnswer: 'Open answer',
    addQuestion: 'Add question',
    addSection: 'Add section',
    deleteSurvey: 'Delete survey',
    doYouWantToRemoveSurvey: 'Do you want to remove survey?',
    yesNo: 'Yes/No',
    confirmation: 'Confirmation',
    manageRunningPrograms: 'Manage running programs',
    numberOfSections: 'Number of sections',
    thisToolHelpsYouToControlAllRunningProgramsAndTrackTheirInfluenceToStudents: 'This tool helps you to control all running programs and track their influence to students',
    currentPrograms: 'Current programs',
    yourRunningProgramListIsEmptyStartByAddingOneFromTheListOfPrograms: 'Your running program list is empty, start by adding one from the list of programs',
    deleteProgram: 'Delete program',
    days: 'days',
    surveyIsCreated: 'Survey is created',
    yes: 'Yes',
    no: 'No',
    configureSurvey: 'Configure survey',
    editSurvey: 'Edit Survey',
    runSurvey: 'Run survey',
    selectMyStudents: 'Select my students',
    openFavorites: 'Open Favorites',
    thereIsNoDataToShow: 'There is no data to show',
    selectAll: 'Select all',
    deselectAll: 'Deselect all',
    saveAsFavorite: 'Save as favorite',
    doYouWantToDeleteFavorite: 'Do you want to delete Favorite group?',
    saveYourFavoriteGroup: 'Save your favorite group',
    deleteWasSuccessful: 'Delete was successful.',
    listOf: 'List of : ',
    deleteThis: 'Delete this ',
    editThis: 'Edit this ',
    youHaveNoChats: 'You have no chats',
    reminderSetFor: 'Reminder set for ',
    doYouWantToDeleteThisTask: 'Do you want to delete this task?',
    repeat: 'Repeat',
    thisSurveyCanBeAnalyzed: 'This survey can be analyzed',
    doesNotRepeat: 'Does not repeat',
    onceAWeek: 'Once a week',
    onceAMonth: 'Once a month',
    repeatsOn: 'Repeats on',
    every: 'Every',
    ofEveryMonth: 'of every month',
    addToWellbeingTracker: 'Add to Wellbeing Tracker',
    addToAnalytics: 'Add to analytics',
    wellbeingTracker: 'Wellbeing Tracker',
    assignedActions: 'Assigned actions',
    reminder: 'Reminder',
    youDontHaveAnyAssignedAction: 'You have no assigned actions yet',
    assignAction: 'Assign action',
    AssignActionToATeacherToCheckOnThisStudent: 'Assign action to a teacher to check on this student',
    assignToTeacher: 'Assign to teacher',
    chooseFromOurRangeOfReadyToGoProgramsDesignedToSupportYourStudentsAndSaveYouTimesNow:
        'Choose from our range of ready-to-go programs designed to support your students and save you times now',
    journals: 'Journals',
    assignedTo: 'Assigned to:',
    selectTeacher: 'Select teacher',
    createAQuestion: 'Create a question',
    turnOff: 'Turn off',
    weekly: 'Weekly',
    monthly: 'Monthly',
    endOfRecurrence: 'End of recurrence',
    everyMonthOn: 'Every month on',
    until: 'Until',
    occursEvery: 'Occurs every',
    staffLogin: 'Staff login',
    token: 'Token',
    createYourOwn: 'Create your own',
    readyToGo: 'Ready-to-go',
    favorites: 'Favorites',
    addToFavorites: 'Add to favorites',
    Attention: 'Attention',
    toEnsureYourPrivacyThisKeyIsNotRecoverableAllYourNotesWillBeLostIfYouForgetThisKey:
        'To ensure your privacy, this key is not recoverable. All your notes will be lost if you forget this key!',
    findTheRightSolution: 'Find the right solution',
    changeSecurityKey: 'Change security key',
    passwordSetup: 'Password setup',
    'Take it': 'Take it',
    open_poll: 'Open poll',
    open_question: 'Open question',
    open_journal: 'Open journal',
    open_survey: 'Open survey',
    'How are you?': 'How are you?',
    'Type an action': 'Type an action',
    actionComment: 'Action comment',
    lastNote: 'Last note',
    Overdue: 'Overdue',
    'Do you want to close this counseling profile?': 'Do you want to close this counseling profile?',
    'Do you want to open this counseling profile?': 'Do you want to open this counseling profile?',
    'This counseling profile is open!': 'This counseling profile is open!',
    'This counseling profile is closed!': 'This counseling profile is closed!',
    'Reminder has been removed!': 'Reminder has been removed!',
    'Assign action': 'Assign action',
    'Export data': 'Export data',
    'Message only visible to staff with special access': 'Message only visible to staff with special access',
    'Message is visible to all': 'Message is visible to all',
    'Set a date when you would like to be reminded about this student': 'Set a date when you would like to be reminded about this student',
    'Choose a date': 'Choose a date',
    'Teacher is created and password has been sent!': 'Teacher is created and password has been sent!',
    'Teacher is not created!': 'Teacher is not created!',
    'Teacher is removed!': 'Teacher is removed!',
    'Teacher is not removed!': 'Teacher is not removed!',
    students: 'Students',
    'Unregistered teachers': 'Unregistered teachers',
    'Unregistered users': 'Unregistered users',
    'Registered teachers': 'Registered teachers',
    'Registered users': 'Registered users',
    'Login data': 'Login data',
    noAnswer: 'No answer',
    changeStatus: 'Change status',
    answerOnHowAreYou: 'Answer on “How are you?”',
    'Your Upstrive (Tasks)': 'Your Upstrive (Tasks)',
    'Take a look what’s on your plate': 'Take a look what’s on your plate',
    'Click to get back to all Tasks': 'Click to get back to all Tasks',
    chooseTheAnswer: 'Choose the answer',
    'Type any additional text here': 'Type any additional text here',
    'Write the answer': 'Write the answer',
    '7 Days': '7 Days',
    '3 Months': '3 Months',
    '1 Month': '1 Month',
    '1 Year': '1 Year',
    'all emotions': 'All emotions',
    'Trend of your classrooms': 'Trend of your classrooms',
    'of students using “How are you” at least once per week': 'of students using “How are you” at least once per week',
    'All emotions': 'All emotions',
    good: 'good',
    numb: 'numb',
    worried: 'worried',
    negative: 'Negative',
    'Wellbeing of your classrooms': 'Wellbeing of your classrooms',
    'User activity': 'User activity',
    'Current Emotion': 'Current Emotion',
    'Most Popular Emotion': 'Most Popular Emotion',
    'Stop editing': 'Stop editing',
    'Add note': 'Add note',
    'Class is updated!': 'Class is updated!',
    'Class is not updated!': 'Class is not updated!',
    'Student is created!': 'Student is created!',
    'Student is not created!': 'Student is not created!',
    'Add a teacher': 'Add a teacher',
    'Add a new class': 'Add a new class',
    'Last login': 'Last login',
    Journals: 'Journals',
    currentEmotion: 'Current Emotion',
    mostPopularEmotion: 'Most Popular Emotion',
    messageIsVisibleToAll: 'Message is visible to all',
    messageOnlyVisibleToStaffWithSpecialAccess: 'Message only visible to staff with special access',
    assignActionSuccess: 'Assign action success',
    filterIsNotSet: 'Filter is not set!',
    commentHasBeenSeen: 'Comment has been seen!',
    catchUp: 'Catch up',
    catchUpOnAnyStudentCommentsAttachedTo: 'Catch up on any student comments attached to an uncomfortable emotion that may have been missed along the way',
    unseen: 'Unseen',
    markAsSeen: 'Mark as seen',
    fullTraining: 'Full Training',
    individualFeaturesTraining: 'Individual Features Training',
    instructionVideosForStaff: 'Instructions video for Staff',
    noteHasBeenDeleted: 'Note has been deleted',
    deleteYourPrivateNote: 'Delete your private note?',
    emotions: 'Emotions',
    studentRemoved: 'Student removed',
    fileHasBeenUploadedDataWillBeUpdatedWithin24Hours: 'File has been uploaded. Data will be updated within 24 hours',
    Neutral: 'Neutral',
    downloadTemplateFile: 'Download Template File',
    previousUploads: 'Previous uploads',
    fileLink: 'File link',
    attachFile: 'Attach file',
    uploadData: 'Upload data',
    noUnsignedTeachers: 'No unsigned teachers',
    noUnsignedStudents: 'No unsigned students',
    reviewYourLoginStatistics: 'Review your login statistics',
    registeredStudents: 'Registered students',
    unregisteredStudents: 'Unregistered students',
    uploadUserData: 'Upload user data',
    addATeacher: 'Add a teacher',
    addANewClass: 'Add a new class',
    enterStudentsDetails: "Enter student's details",
    enterTeachersDetails: "Enter teacher's details",
    cantCreateStudentWithoutCreateClass: 'Can`t create student without create class',
    createWellbeingProfile: 'Create Wellbeing profile',
    yourStudentListIsEmpty: 'Your students list is empty',
    addAStudent: 'Add a student',
    openClassQRCodes: 'Open Class QR Codes',
    generatingClassQRCodes: 'Generating QR codes…',
    print: 'Print',
    noActiveStudentsForQR: 'This class has no active students to generate QR codes for.',
    letThemSetTheirOwnPasswordsAfterLogin: 'Let them set their own passwords after login',
    keepThisPassword: 'Keep this password',
    rolemodelIsnotLoaded: 'Role model is not loaded... Please refresh page!',
    loginData: 'Login data',
    exportData: 'Export data',
    passwordIsNotCorrect: 'Password is not correct',
    deleteStudent: 'Delete student',
    deleteTeacher: 'Delete teacher',
    hidePasswordmanager: 'Hide password manager',
    setStudentsPasswordManually: "Set student's password manually",
    generateNewPassword: 'Generate new password',
    lastName: 'Last name',
    noStudentsYet: 'No students yet',
    loggedIn: 'Logged in',
    teacherRole: 'Teacher role',
    'Select this teacher’s role': 'Select teacher role',
    thisTeacherWillbe: 'This teacher will be',
    itAccess: 'IT Access',
    itAccessRightText: 'User management only',
    itAccessConfirm: 'This teacher will only be able to manage users from the web app.',
    noPermissionTitle: "You don't have permission to view this page",
    noPermissionSubtitle: 'Your IT Access role is limited to User Management.',
    goToUserManagement: 'Go to User Management',
    classIsUpdated: 'Class is updated!',
    classIsNotUpdated: 'Class is not updated!',
    teacherIsCreatedAndPasswordHasBeenSent: 'Teacher is created and password has been sent.',
    teacherIsNotCreated: 'Teacher is not created!',
    createYourOwnContent: 'Create Your Own Content',
    contentDeleted: 'Content deleted',
    upcomingContent: 'Upcoming Content',
    overview: 'Overview',
    feedPosts: 'Feed Posts',
    welcomeBack: 'Welcome back',
    ofStudentsUsingHowAreYouTodayAtLeastOncePerWeek: '% of students using “How are you today?” at least once per week',
    yourClassroom: 'Your Classroom',
    checkWhatsGoingOn: 'Check what’s going on',
    myClassroom: 'My Classroom',
    youDeletedTargetGroup: 'You deleted target group',
    deeperInsights: 'Deeper Insights',
    findYourStudentsWhoAreLoggingUncomfortableEmotions: 'Find your students who are logging uncomfortable emotions',
    monitoringGroups: 'Monitoring groups',
    createGroup: 'Create Group',
    whatIsIt: 'What is it?',
    createdNewMonitoringGroup: 'Created new monitoring group!',
    updatedMonitoringGroup: 'Updated monitoring group!',
    nameANewGroup: 'Name a new group',
    chooseEmotions: 'Choose emotions',
    close: 'Close',
    actionRequired: 'Action Required',
    stayUpToDateWithStudentSupport: 'Stay up to date with student support',
    actionsAssignedToMe: 'Actions assigned to me',
    studentChat: 'Student chat',
    unreadMessage: 'unread message',

    unreadMessage_zero: 'No unread messages',
    unreadMessage_one: '{{count}} unread message',
    unreadMessage_other: '{{count}} unread messages',
    assignedBy: 'Assigned by',
    addNote: 'Add note',
    engagementStatistics: 'Engagement Statistics',
    trackEngagementResponsivenessLogins: 'Track engagement, responsiveness & logins',
    analytics: 'Analytics',
    ofStudentsUsingUpstriveWeekly: '% of students using  Upstrive weekly',
    ofResponsesToActivePollsQuestion: '% of responses to active polls questions',
    ofTeachersLoggedIn: '% of teachers logged in',
    ofStudentsLoggedIn: '% of students logged in',
    displayAll: 'Display All',
    'display all': 'Display All',
    'Display all': 'Display all',
    onlyMine: 'Only mine',
    searchResults: 'Search results',
    filter: 'Filter',
    from: 'From',
    to: 'To',
    notSelected: 'Not selected',
    questions: 'Questions',
    Questions: 'Questions',
    polls: 'Polls',
    Polls: 'Polls',
    runReadyToGo: 'Run ready-to-go',
    journal: 'Journal',
    target: 'Target',
    clickToBrowseResults: 'Click to browse results',
    by: 'By',
    archived: 'Archived',
    download: 'Download',
    thereIsntAnyAnswerYet: "There isn't any answer yet",
    start: 'Start',
    createPosts: 'Create Posts',
    deleteFeedContent: 'Delete feed content?',
    selectEmotionThatBestDescribesYourMoodToday: 'Select an emotion that best describes your mood today',
    yourTasks: 'Your Tasks',
    activitiesForCompletion: 'Activities for completion',
    congratulations: 'Congratulations',
    youHaveCompletedAllYourTasks: 'You have completed all your tasks.',
    typeAnyAdditionalTextHere: 'Type any additional text here',
    submitAnswer: 'Submit answer',
    yourResultsAreSaved: 'Your results are saved!',
    'Take Survey': 'Take Survey',
    runReadyToGoContent: 'Run ready-to-go content',
    selectOneOption: 'Select one option',
    youHaveMissedThisQuestion: 'You have missed this question',
    finish: 'Finish',
    nextSection: 'Next section',
    yourAnswersAreSaved: 'Your answers are saved!',
    yourBrowserDoesNotSupportHTMLVideo: 'Your browser does not support HTML video.',
    whatIsTheMainReason: 'What’s the main reason?',
    pickUpTo3: 'Pick up to 3',
    myself: 'myself',
    family: 'family',
    friends: 'friends',
    school: 'school',
    'social media': 'social media',
    wellbeing: 'wellbeing',
    health: 'health',
    achievement: 'achievement',
    sleep: 'sleep',
    Myself: 'Myself',
    Family: 'Family',
    Friends: 'Friends',
    'Social media': 'Social media',
    Wellbeing: 'Wellbeing',
    Health: 'Health',
    School: 'School',
    Achievement: 'Achievement',
    Sleep: 'Sleep',
    howDoYouFeelComparedToLastTimeYouLoggedIn: 'How do you feel compared to the last time you logged in?',
    iDontWantToThinkAboutItNow: 'I don’t want to think about it now',
    stepBack: 'Step back',
    whatCouldYouDoToImproveThingsRightNow: 'What could you do to improve things right now?',
    yourFeedBackHasBeenSubmited: 'Your feedback has been submitted!',
    useTemplate: 'Use Template',
    templateDeleted: 'Template deleted',
    fileIsToBig: 'File is too big!',
    templateIsUpdated: 'Template is updated',
    templateIsNotUpdated: 'Template is not updated',
    templateIsNotDeleted: 'Template is not deleted',
    contentNeedsToBeReviewedByTheScoolAdmin: 'Content needs to be reviewed by the school admin!',
    headline: 'Headline',
    typeHeadlineHere: 'Type headline here',
    supportiveText: 'Supportive Text',
    enterLinkOptional: 'Enter Link (optional)',
    writeOption1Here: 'Write option 1 here',
    deleteOption: 'Delete option',
    'Select target': 'Select target',
    pleaseFillRequiredFields: 'Please fill required fields',
    updateTemplate: 'Update template',
    templateIsSaved: 'Template is saved!',
    publish: 'Publish',
    surveyIsCreatedAsTemplate: 'Survey is created as template!',
    surveyIsDeleted: 'Survey is deleted!',
    moveSectionUp: 'Move section up',
    moveSectionDown: 'Move section down',
    headlineForSection: 'Headline for section',
    descriptionForSection: 'Description for section',
    moveQuestionUp: 'Move question up',
    moveQuestionDown: 'Move question down',
    selectTypeOfQuestion: 'Select type of question',
    writeOption: 'Write option {{result}} here',
    setupADateAndTime: 'Set up a Date & Time',
    endDate: 'End date',
    selectACategory: 'Select a category',
    selectSpecificYearGroupsToGatherMoreInformationFrom: 'Select specific year groups to gather more information from',
    customize: 'Customize',
    selectYourFavoriteGroup: 'Select your favorite group',
    selectCustom: 'Select Recipients',
    setATime: 'Set a time',
    readyToGoContent: 'Ready-to-go Content',
    sortBy: 'Sort by',
    type: 'Type',
    topic: 'Topic',
    evidenceBasedContentPreparedForYouByOurTeamOfExperts: 'Evidence-based content prepared for you by our team of experts',
    'Choose from our range of ready-to-go programs designed to support your students and save you time':
        'Choose from our range of ready-to-go programs designed to support your students and save you time.',
    'Each of our ready-to-go surveys is designed to help you understand your students better':
        'Each of our ready-to-go surveys is designed to help you understand your students better.',
    'Pick a journal that will keep your students engaged': 'Pick a journal that will keep your students engaged.',
    currentlyRunning: 'Currently running',
    running: 'Running',
    paused: 'Paused',
    playProgram: 'Play program',
    pauseProgram: 'Pause program',
    doYouWantToDeleteThisProgram: 'Do you want to delete this program?',
    doYouWantToStartThisProgram: 'Do you want to start this program?',
    doYouWantToStopThisProgram: 'Do you want to stop this program?',
    postIndividually: 'Post individually',
    lastCreated: 'Last created',
    youMustSelectTargetGroup: 'You must select target group!',
    youMustSelectDaysOfWeek: 'You must select days of week!',
    Sun: 'Sun',
    Mon: 'Mon',
    Tue: 'Tue',
    Wed: 'Wed',
    Thu: 'Thu',
    Fri: 'Fri',
    Sat: 'Sat',
    runIt: 'Run it',
    classroomTrends: 'Classroom Trends',
    searchForStudent: 'Search for student',
    searchForTeacher: 'Search for teacher',
    uncomfortable: 'Uncomfortable',
    Emotions: 'Emotions',
    filterClassroom: 'Filter Classroom',
    yourIndividualStudentsResponses: 'Your individual students’ responses',
    uncomfortableEmontionsWithComments: 'Uncomfortable emotions with comments',
    wellbeingOfTeachers: 'Wellbeing of teachers',
    youMustFillData: 'You must fill data',
    actionHasBeenAssignedToTeacher: 'Action has been assigned to teacher',
    assignActionFailed: 'Assign action failed',
    sendMessage: 'Send message',
    classroomTeacher: 'Classroom Teacher',
    headOfYear: 'Head of Year',
    otherTeachers: 'Other Teachers',
    typeAnAction: 'Type an action',
    sendPrivateMessageToStudent: 'Send a personal message to the student',
    messageHasBeenSent: 'Message has been sent',
    getDeeperInsights: 'Get deeper insights',
    searchQuestion: 'Search question',
    clickToSeeQuestionInDetails: 'Click to see question in details',
    getDeeperInsightsIntoYourStudentsEmotionalTrends: 'Get deeper insights into your students emotional trends',
    getInsights: 'Get insights',
    totalCommentsLeftUsingHowAreYouToday: 'Total comments left using “How are you today?”',
    basics: 'Basics',
    getBackToMainAnalytics: 'Get Back to Main Analytics',
    searchStudents: 'Search students',
    lastLogin: 'Last login',
    neverLoggedIn: 'Never logged in',
    loggedInRecently: 'Logged in recently',
    studentsNotFound: 'Students not found',
    showMoreStudents: 'Show more students',
    searchTeachers: 'Search Teachers',
    position: 'Position',
    teachersNotfound: 'Teachers not found',
    showMoreTeachers: 'Show more teachers',
    studentsWhoDidntRespondToAnyQuestionInPastTwoWeeks: 'Students who didn`t respond to any question in past two weeks',
    thisCanTakeAwhile: 'This can take a while',
    barView: 'Bar View',
    averageResponseDistributionForSelectedPeriod: 'Average response distribution for selected period',
    percentageOfResponseDistributionByGender: 'Percentage of response distribution by gender',
    general: 'General',
    percentageOfResponseDistributionIntotalForSelectedPeriod: 'Percentage of response distribution in total for selected period',
    totalCommentsInHowareYouToday: 'Total comments in "How are you today?"',
    emotion: 'Emotion',
    noOfCommentsAnsweringHowAreYouToday: 'No. of comments answering, “How are you today?”',
    change: 'Change',
    mostCommonReasons: 'Most common reasons',
    thereIsnotAnyConversationYet: 'There isn`t any conversation yet',
    replyOn: 'Reply on',
    myMessage: 'My message',
    'Track student task responses': 'Track student task responses',
    'Full name': 'Full name',
    "You can't delete yourself!": "You can't delete yourself!",
    'This day is locked!': 'This day is locked!',
    'Multiple years': 'Multiple years',
    '% of all students are with selected type of emotions': '% of all students are with selected type of emotions.',
    'It is 71% less then on previous week': 'It is {{num}}% less then on previous week',
    'It is 71% more then on previous week': 'It is {{num}}% more then on previous week',
    cannotCreateAnonymousSurveyFor1User: 'Cannot create anonymous survey for 1 user',
    'Cannot create anonymous poll for 1 user': 'Cannot create anonymous poll for 1 user',
    'Cannot create anonymous poll for 2 users': 'Cannot create anonymous poll for 2 users',
    'Release survey by days': 'Release survey by days',
    "This tool helps you to schedule whole survey once so you don't need to check it all the time":
        "This tool helps you to schedule whole survey once so you don't need to check it all the time",
    mood: 'Mood',
    'Schedule Survey': 'Schedule Survey',
    'Please select file': 'Please select file',
    yourSecretKeyIsSaved: 'Your secret key is saved',
    '1st': '1st',
    '2nd': '2nd',
    '3rd': '3rd',
    '% of responses on active polls & questions': '% of responses on active polls & questions',
    '% of responses on active polls, questions': '% of responses on active polls, questions',
    '% of students using "How are you?" at least once per week': '% of students using "How are you?" at least once per week',
    '% of students using Upstrive (per week, any function)': '% of students using Upstrive (per week, any function)',
    '% of students using “How are you?” at least once per week': '% of students using “How are you?” at least once per week',
    '% of teachers using Upstrive (per week, any function)': '% of teachers using Upstrive (per week, any function)',
    '% this week': '% this week',
    'Action Required': 'Action Required',
    'Action needed': 'Action needed',
    'Action taken': 'Action taken',
    'Actions assigned to me': 'Actions assigned to me',
    'Actions required': 'Actions required',
    'Add reminder': 'Add reminder',
    'Add section': 'Add section',
    'Add to Wellbeing Tracker': 'Add to Wellbeing Tracker',
    'Add to favorites': 'Add to favorites',
    AddVideoPhoto: 'Add Video/Photo',
    'Allow more than one answer': 'Allow more than one answer',
    'Ask your manager to assign you to class.': 'Ask your manager to assign you to class',
    'Assign to teacher': 'Assign to teacher',
    'Assign to this teacher': 'Assign to this teacher',
    'Assigned to': 'Assigned to',
    'Assignment for': 'Assignment for',
    'At least 8 characters': 'At least 8 characters',
    Browse: 'Browse',
    By: 'By',
    'Cannot create anonymous survey for 1 user': 'Cannot create anonymous survey for 1 user',
    'Catch-up': 'Catch-up',
    Category: 'Category',
    Chat: 'Chat',
    'Check for any student comments that may have been overlooked': 'Check for any student comments that may have been overlooked',
    'Choose topic': 'Choose topic',
    'Choose your answer': 'Choose your answer',
    'Class info': 'Class info',
    'Classroom Teacher': 'Classroom Teacher',
    'Classroom Trends': 'Classroom Trends',
    'Click on emotion to go into the classroom details': 'Click on emotion to go into the classroom details',
    'Click to copy email': 'Click to copy email',
    'Comment has been seen!': 'Comment has been seen!',
    Comments: 'Kommentare',
    'Comments for review': 'Comments for review',
    'Configure survey': 'Configure survey',
    'Congrats, everything is done for now!': 'Congrats, everything is done for now!',
    'Congratulations!': 'Congratulations!',
    Copied: 'Copied',
    'Create Group': 'Create Group',
    'Create Group and Apply filter': 'Create Group and Apply filter',
    'Create Wellbeing profile': 'Create Wellbeing profile',
    'Create a question': 'Create a question',
    'Create a survey': 'Create a survey',
    'Create something and see the results live!': 'Create something and see the results live!',
    'Create your own': 'Create your own',
    'Create your own customized group to gather information from': 'Create your own customized group to gather information from',
    'Created new monitoring group!': 'Created new monitoring group!',
    'Creation shortcuts for you': 'Creation shortcuts for you',
    'Current programs:': 'Current programs:',
    Customize: 'Customize',
    Date: 'Date',
    'Date of Birth': 'Date of Birth',
    Day: 'Day',
    Default: 'Default',
    'Delete survey': 'Delete survey',
    'Delete the template for title': 'Delete the template for {{title}}',
    'Delete this favorite group?': 'Delete this favorite group?',
    'Delete this feed?': 'Delete this feed?',
    'Delete this note?': 'Delete this note?',
    'Delete this poll?': 'Delete this poll?',
    'Delete this post?': 'Delete this post?',
    'Delete this program?': 'Delete this program?',
    'Delete this question?': 'Delete this question?',
    'Delete this survey?': 'Delete this survey?',
    'Describe how will you take action about this student': 'Describe how will you take action about this student',
    'Display All': 'Display All',
    'Do not agree': 'Do not agree',
    'Do you think things are same for any reason in particular?': 'Do you think things are same for any reason in particular?',
    Download: 'Download',
    'Easily manage your students and teachers, using separate functions': 'Easily manage your students and teachers, using separate functions',
    'Edit Group': 'Edit Group',
    'Edit Group and Apply filter': 'Edit Group and Apply filter',
    'Edit Survey': 'Edit Survey',
    'Engagement Statistics': 'Engagement Statistics',
    'Enter Link (optional)': 'Enter Link (optional)',
    'Enter a question here': 'Enter a question here',
    'Enter any url here': 'Enter any url here',
    'Enter your note here': 'Enter your note here',
    'Export report': 'Export report',
    Favorite: 'Favorite',
    Favorites: 'Favorites',
    'Feed Posts': 'Feed Posts',
    Filter: 'Filter',
    'Filter Classroom': 'Filter Classroom',
    'Filter Emotions': 'Filter Emotions',
    'Filter by dates': 'Filter by dates',
    'Filter posts': 'Filter posts',
    'Filter results': 'Filter results',
    'Find out more about your students’ & colleagues’ experiences of stress with a survey and support them with a range of stress management tools.':
        'Find out more about your students’ & colleagues’ experiences of stress with a survey and support them with a range of stress management tools.',
    Finish: 'Finish',
    'Finish later': 'Finish later',
    From: 'From',
    'General Wellbeing': 'General Wellbeing',
    'Head of Year': 'Head of Year',
    Headline: 'Headline',
    'Headline for poll': 'Headline for poll',
    'Headline for question': 'Headline for question',
    'Here you’ll find more personal wellbeing content designed to help you and your students learn more about specific challenges and ways to overcome them.':
        'Here you’ll find more personal wellbeing content designed to help you and your students learn more about specific challenges and ways to overcome them.',
    'Here’s what happened while you were away': 'Here’s what happened while you were away',
    History: 'History',
    Home: 'Home',
    'How do you feel compared to last time you logged in?': 'How do you feel compared to last time you logged in?',
    'I Care / I Listen': 'I Care / I Listen Chat',
    "I confirm that I read and agree to Upstrive's": "I confirm that I have read and agree to Upstrive's",
    'I do not agree': 'I do not agree',
    'I have an issue related to': 'I have an issue related to',
    'I will take action': 'I will take action',
    'If it’s a school-related topic such as getting organised, excelling in exams, or being productive, it’s right here for you!':
        'If it’s a school-related topic such as getting organised, excelling in exams, or being productive, it’s right here for you!',
    "If you don't agree to Terms and Conditions or Privacy Policy you are not going to be allowed to use the app!":
        "If you don't agree to Terms and Conditions or Privacy Policy you are not going to be allowed to use the app!",
    'Language is changed': 'Language is changed',
    "List of students who haven't logged in yet and it’s ": "List of students who haven't logged in yet and it’s ",
    'Log comment': 'Log comment',
    'Login info': 'Login info',
    'Manage running programs': 'Manage running programs',
    'Mark as seen': 'Mark as seen',
    'Media file is too big. Try smaller one': 'Media file is too big. Try smaller one',
    Menu: 'Menu',
    'Message has been sent to student!': 'Message has been sent to student!',
    'Monitoring group': 'Monitoring group',
    'Multiple classes': 'Multiple Classes',
    'My Classroom': 'My Classroom',
    'My message': 'My message',
    'Name a new group type here': 'Name a new group type here',
    'New Version is Available': 'New Version is Available',
    'New survey!': 'New survey!',
    Next: 'Next',
    No: 'No',
    'No comments': 'No comments',
    'No items found': 'No items found',
    'No one yet': 'No one yet',
    'No unseen replies left': 'No unseen replies left',
    'Number of answers': 'Number of answers',
    OK: 'OK',
    Off: 'Off',
    'Open link': 'Open link',
    'Open list': 'Open list',
    'Open survey results': 'Open survey results',
    Option: 'Option',
    'Other Teachers': 'Other Teachers',
    'Our range of social and emotional learning (SEL) content is all designed to help you & your students enhance self-awareness and develop greater self-management skills.':
        'Our range of social and emotional learning (SEL) content is all designed to help you & your students enhance self-awareness and develop greater self-management skills.',
    Overview: 'Overview',
    'Pending Content': 'Pending Content',
    'Personal Wellbeing': 'Personal Wellbeing',
    'Pick one option': 'Pick one option',
    'Pick one or more options': 'Pick one or more options',
    'Pick time:': 'Pick time:',
    'Pick up to 3': 'Pick up to 3',
    'Post individual': 'Post individual',
    Posts: 'Posts',
    Previous: 'Previous',
    Programs: 'Programs',
    'Ready-to-go': 'Ready-to-go',
    'Reminder for today': 'Reminder for today',
    Repaet: 'Repaet',
    'Retrieving data. Wait a few seconds and try to cut or copy again.': 'Retrieving data. Wait a few seconds and try to cut or copy again.',
    'Run a journal': 'Run a journal',
    'Run a survey': 'Run a survey',
    'Run it': 'Run it',
    'Run program': 'Run program',
    Running: 'Running',
    SEL: 'SEL',
    'Save Survey': 'Save Survey',
    'Save your favorite group': 'Save your favorite group',
    'Search results': 'Search results',
    Section: 'Section',
    Sections: 'Sections',
    'Seen by': 'Seen by',
    'Seen by:': 'Seen by:',
    'Select a category': 'Select a category',
    'Select all': 'Select all',
    'Select days:': 'Select days:',
    'Select emotion that fits your mood': 'Select emotion that fits your mood',
    'Select from favorites': 'Select from favorites',
    'Select one item from the list': 'Select one item from the list',
    'Select one option': 'Select one option',
    'Select one or more items from the list': 'Select one or more items from the list',
    'Select specific classes to gather more information from': 'Select specific classes to gather more information from',
    'Select specific teachers you would like to get information from': 'Select specific teachers you would like to get information from',
    'Select specific year groups to gather more information from': 'Select specific year groups to gather more information from',
    'Select teacher': 'Select teacher',
    'Select what to display': 'Select what to display',
    'Select your favorite group': 'Select your favorite group',
    'Self-management': 'Self-management',
    'Send Private message to student': 'Send Private message to student',
    'Send message to all students': 'Send message to all students',
    'Send message to all teachers': 'Send message to all teachers',
    'Setup your filter': 'Setup your filter',
    'Show more programs': 'Show more programs',
    'Show more surveys': 'Show more surveys',
    solutions: 'Solutions',
    'Sorry, your school restricted access to this module': 'Sorry, your school restricted access to this module',
    'Start date:': 'Start date:',
    'Stop tracking live results for title': 'Stop tracking live results for {{title}}',
    'Stress Management': 'Stress Management',
    'Student chat': 'Student chat',
    'Students login data': 'Students login data',
    'Supportive Text': 'Supportive Text',
    'Survey has been created': 'Survey has been created',
    'Survey needs to be reviewed by the school admin': 'Survey needs to be reviewed by the school admin',
    'Survey results': 'Survey results',
    Surveys: 'Surveys',
    'Take it later': 'Take it later',
    'Take it now': 'Take it now',
    Target: 'Target',
    'Target group is not selected': 'Target group is not selected',
    'Target group:': 'Target group:',
    'Tasks archive': 'Tasks archive',
    'Teacher only': 'Teacher only',
    'Terms and Conditions': 'Terms and Conditions',
    'Terms and Conditions and Privacy Policy': 'Terms and Conditions and Privacy Policy',
    'The maximum image size for download is 1400px x 1400px': 'The maximum image size for download is 1400px x 1400px',
    'This is a great place to start if you’re looking for some general wellbeing content before diving into some of the more specific topics.':
        'This is a great place to start if you’re looking for some general wellbeing content before diving into some of the more specific topics.',
    'This tool helps you to control all running programs and track their influence to students':
        'This tool helps you to control all running programs and track their influence to students',
    'This tool helps you to run a survey for your students': 'This tool helps you to run a survey for your students',
    "This tool helps you to schedule whole program once so you don't need to check it all the time":
        "This tool helps you to schedule whole program once so you don't need to check it all the time",
    Time: 'Time',
    To: 'To',
    'Track Counseling': 'Track Counseling',
    'Type 1st thing here': 'Type 1st thing here',
    'Type a question': 'Type a question',
    'Type a survey title': 'Type a survey title',
    'Type here': 'Type here',
    'Type name for your note here': 'Type name for your note here',
    'Type name in the field below': 'Type name in the field below',
    Uncomfortable: 'Uncomfortable',
    Unseen: 'Unseen',
    'Upcoming Content': 'Upcoming Content',
    'Updated monitoring group!': 'Updated monitoring group!',
    'Use Template': 'Use Template',
    'View Details': 'View Details',
    'Wait for new tasks...': 'Wait for new tasks...',
    'We hope you’ve had a good day!': 'We hope you’ve had a good day!',
    'Welcome back': 'Welcome back',
    'Wellbeing Tracker': 'Wellbeing Tracker',
    'wellbeing tracker': 'Wellbeing Tracker',
    "What's the main reason?": "What's the main reason?",
    'Write option': 'Write option',
    'Write personal message for the student here': 'Write personal message for the student here',
    'Write your thoughts here': 'Write your thoughts here',
    Yes: 'Yes',
    'You are not allowed to create content': 'You are not allowed to create content',
    'You are not in charge of this student so your messages will be forwarded to school admin or counselor':
        'You are not in charge of this student so your messages will be forwarded to school admin or counsellor',
    'You can press yellow button and create a new Wellbeing profile': 'You can press yellow button and create a new Wellbeing profile',
    "You don't have any incoming content": "You don't have any incoming content",
    'You have a survey about': 'You have a survey about',
    'You have completed all your tasks': 'You have completed all your tasks',
    'You have no chats': 'You have no chats',
    'You have no data about your classroom': 'You have no data about your classroom',
    'You have no live content': 'You have no live content',
    'You have to select at least one emotion': 'You have to select at least one emotion',
    'You will be logged out': 'You will be logged out',
    'Your Classrooms': 'Your Classrooms',
    'Your counseling list is empty, start with adding a new counseling profile for one of your students':
        'Your counseling list is empty, start with adding a new counseling profile for one of your students.',
    'Your list is empty': 'Your list is empty',
    'Your results are saved!': 'Your results are saved!',
    'Your running program list is empty, start by adding one from the list of programs': 'Your running program list is empty, start by adding one from the list of programs',
    'Your tasks': 'Your tasks',
    'add a survey description': 'add a survey description',
    addPhotoVideo: 'Add Photo/Video',
    anonymousPoll: 'Anonymous poll',
    anonymousQuestion: 'Anonymous question',
    anonymous_journal: 'Anonymous journal',
    anonymous_poll: 'Anonymous poll',
    anonymous_question: 'Anonymous question',
    anonymous_survey: 'Anonymous survey',
    atLeast8Caracters: 'At least 8 caracters',
    closePopup: 'Close pop-up',
    closePopUp: 'Close pop-up',
    completed: 'completed',
    connectWithTheConselor: 'Connect with counsellor',
    'copy message': 'copy message',
    'enter a section description here': 'enter a section description here',
    'enter a section title here': 'Enter a section title here',
    experienceIt: '% experience it',
    expertRecommendation: 'Expert recommendation',
    exploreThingsYouCanDoRightNow: 'Explore things you can do right now',
    feelingBetterQuestion: 'Nice to hear that the situation has improved. Do you have ideas on how you could possibly make it even better?',
    feelingMuchWorseQuestion: "We're sorry to hear that you're feeling worse. Which of the suggestions below can help you right now?\"",
    feelingSameQuestion: 'What can you do right now to make your situation better?',
    goodToHearThingsAreBetter: 'Good to hear things are better.',
    greatToHearThingsAreMuchBetter: 'Great to hear things are much better.',
    here: 'here',
    howToDealWithThisProblem: 'How to deal with this problem?',
    iHaveAnIssueRelatedTo: 'I have an issue related to...',
    instructionVideo: 'Instruction Video',
    loadingMoreFeeds: 'Loading more feeds',
    majorUpdate: 'Major Update',
    mandatory: 'mandatory',
    mobileAndDesktopStudentVersion: 'Mobile and Desktop - Student Version.mp4',
    next: 'Next',
    notReally: 'Not really',
    oopsThereSeemsToBeAnIssueWithConnection: 'Oops there seems to be an issue with connection',
    openJournal: 'Open journal',
    openQuestion: 'Open question',
    pleaseTryAgainInAFewMinutestOrContactUpstriveSupport: 'Please try again in a few minutes or contact Upstrive Support',
    privateNotes: 'Private notes',
    quickTips: 'Quick tips',
    read: 'read',
    rememberMe: 'Remember me',
    remove: 'Remove',
    returnBack: 'Return back',
    sameGreatAppFreshNewLook: 'Same great app fresh new look!',
    seeHowOtherStudentsHandleThis: 'See how other students handle this',
    sorryToHearThatThingsAreMuchWorse: 'Sorry to hear that things are much worse.',
    sorryToHearThatThingsAreWorse: 'Sorry to hear that things are worse.',
    sorryYourSchoolRestrictedAccessToThisModule: 'Sorry your school restricted access to this module.',
    sos: 'SOS',
    thingsYouCanDoRightNow: 'Things you can do right now',
    typeOneThingHere: 'Type one thing here',
    typeYourAnswerHere: 'Type your answer here',
    voluntary: 'voluntary',
    wasThisSolutionHelpful: 'Was this solution helpful?',
    weHopeYouHaveAGoodDay: 'We hope you have a good day!',
    whatAre3ThingsThatAreABitChallengingAtTheMoment: 'What are 3 things that are a bit challenging at the moment?',
    whatsJustOneThingYouWillDoDifferentlyTomorrow: 'What is just one thing you will do differently tomorrow? ',
    whatsNew: "What's new?",
    yesThanks: 'Yes Thanks!',
    filterResults: 'Filter results',
    'Add student': 'Add student',
    'Select surveys': 'Select surveys',
    'Type of class to create': 'Type of class to create',
    Regular: 'Regular',
    Primary: 'Primary',
    'Primary class': 'Primary class',
    Avatar: 'Avatar',
    'Not Setuped': 'Not Setuped',
    'Transfer to another class': 'Transfer to another class',
    'You must select class': 'You must select class',
    'Current class': 'Current class',
    'Select new class': 'Select new class',
    'Select class': 'Select class',
    'Change avatar': 'Change avatar',
    'Edit Student': 'Edit Student',
    'Step 1/2': 'Step 1/2',
    'Step 2/2': 'Step 2/2',
    'Choose Gender': 'Choose Gender',
    'Choose animal': 'Choose animal',
    'Create Student': 'Create Student',
    Available: 'Available',
    Taken: 'Taken',
    'If you will choose already taken character it will auto unpin from existing child': 'If you will choose already taken character it will auto unpin from existing child',
    'Choose later': 'Choose later',
    'Save with selected avatar': 'Save with selected avatar',
    'Are you sure you want to delete class?': 'Are you sure you want to delete this class?',
    'All Student in this class will be deleted': 'This will remove all students from this class',
    'No, cancel': 'No, Cancel',
    'Yes, Delete': 'Yes, Delete',
    'Class successfully deleted': 'Class successfully deleted',
    Success: 'Success',
    'Transfer to another class successfully finished': 'Transfer to another class successfully finished',
    'Old class': 'Old class',
    Display: 'Display',
    'Your Primary Classes': 'Your Primary Classes',
    'The new password has been sent!': 'The new password has been sent!',
    'Password delivery failed!': 'Password delivery failed!',
    'File has been removed': 'File has been removed',
    'Preset Ranges': 'Preset Ranges',
    'Last Month': 'Last Month',
    'Last Quarter': 'Last Quarter',
    'Last Year': 'Last Year',
    'Data is saved': 'Data is saved',
    'Allocation of answers from students who answered on “How are you Today?”': 'Allocation of answers from students who answered on “How are you Today?”',
    'New password has already been generated today for this user. Do you want to generate it again?':
        'New password has already been generated today for this user. Do you want to generate it again?',
    'Not logged in': 'Not logged in',
    'Logged in': 'Logged in',
    'Current Weekly Engagement Statistics': 'Current Weekly Engagement Statistics',
    'Student logins': 'Student logins',
    'Student check in': 'Student check in',
    'Student engagement with content': 'Student engagement with content',
    'Teacher logins': 'Teacher logins',
    'This percentage reflects the number of teacher logins for this week': 'This percentage reflects the number of teacher logins so far this week. ',
    'This percentage reflects  students interacting with app content beyond check-ins.':
        'This percentage reflects  students interacting with app content beyond check-ins so far this week.',
    'This percentage reflects students who have both logged in and completed a check-in for the week':
        'This percentage reflects students who have both logged in and completed a check-in so far this week.',
    'This statistic reflects the number of student logins for this week': 'This statistic reflects the number of student logins so far this week',
    'Use this pre-set Sample Group to monitor the uncomfortable emotions your students might log.':
        'Use this pre-set Sample Group to monitor the uncomfortable emotions your students might log.',
    'Sample Group': 'Sample Group',
    'Comfortable Emotions': 'Comfortable Emotions',
    'Uncomfortable Emotions': 'Uncomfortable Emotions',
    clickTheButtonsOnTheRightToAccessSpecificAnalyticsForThoseTimeframes: 'Click the buttons on the right to access specific analytics for those timeframes.',
    effortlesslyMonitorYourStudentsEmotionalExperiencesByCreatingYourOwnCustomisedGroupsHere:
        "Effortlessly monitor your students' emotional experiences by creating your own customised groups here.",
    '% of students responding to "How are you today? at least once a week.': '% of students responding to "How are you today? at least once a week.',
    'No. of comments left in response to "How are you today?': 'No. of comments left in response to "How are you today?"',
    'Emotion distribution for selected period': 'Emotion distribution for selected period',
    'No. of comments left in response to "How are you today?"': 'No. of comments left in response to "How are you today?"',
    'No. of comments responding to, “How are you today?”': 'No. of comments responding to, “How are you today?”',
    'More details': 'More details',
    'Overall engagement': 'Overall engagement',
    'Engagement with emotions': 'Engagement with emotions',
    'Total emotions submitted': 'Total emotions logged',
    'Total number of emotions submitted in the time frame': 'Total number of emotions submitted in the time frame',
    'Relative change to the same selected previous period': 'Relative change to the same selected previous period',
    'No data from the previous period to compare': 'No data from the previous period to compare',
    'No change compared to the previous period': 'No change compared to the previous period',
    'Percent of students that submitted an emotion in the selected time frame': 'Percent of students that submitted an emotion in the selected time frame',
    'Percentage of students that used Upstrive in the period (any function, just opened it)':
        'Percentage of students that used Upstrive in the period (any function, just opened it)',
    'Percentage of students who have experienced these emotions in selected period': 'Percentage of students who have experienced these emotions in selected period',
    'Percentage of teachers who have registered to the app': 'Percentage of teachers who have registered to the app',
    'Percentage of students who have registered to the app': 'Percentage of students who have registered to the app',
    'Percentage of students engaging with content this week': 'Percentage of students engaging with content this week',
    'Percentage of student check-ins this week': 'Percentage of student check-ins this week',
    'Percentage of student logins this week': 'Percentage of student logins this week',
    'Percentage of teacher logins this week': 'Percentage of teacher logins this week',
    'Time period': 'Time period',
    'Time frame': 'Time frame',
    'Add a new trend': 'Add a new trend',
    'Engagement with content': 'Engagement with content',
    'Percentage of students that submitted an emotion in the selected time frame': 'Percentage of students that submitted an emotion in the selected time frame',
    'Percentage of students engaging with content in the selected time frame': 'Percentage of students engaging with content in the selected time frame',
    'Remove from trends': 'Remove from trends',
    'Student engagement with emotions': 'Student engagement with emotions',
    'No. of emotions': 'No. of emotions',
    'Create & Manage Reports': 'Create & Manage Reports',
    'Welcome! Create your first report here': 'Welcome! Create your first report here',
    'Create report': 'Create report',
    'Latest reports': 'Latest reports',
    'View More': 'View More',
    'Return to Analytics': 'Return to Analytics',
    'Create Reports': 'Create Reports',
    'Report format': 'Report format',
    Raw: 'Raw',
    'Output fields': 'Output fields',
    'Target users': 'Target users',
    'Select report dates': 'Select report dates',
    'Remember to set up filters to get started!': 'Remember to set up filters to get started!',
    'Last step': 'Last step',
    'Setup report name as your last step': 'Set up the report name as your final step',
    'Report name': 'Report name',
    'Enter file name': 'Enter file name',
    'You will be notified once your report is ready': 'You will be notified once your report is ready',
    'Report-2024-01-29': 'Report-2024-01-29',
    'Your opinion matters to us!': 'Your opinion matters to us!',
    'Your feedback helps us to improve. If you find our app helpful, please consider rating it.':
        'Your feedback helps us to improve. If you find our app helpful, please consider rating it.',
    'Share your feedback': 'Share your feedback',
    'Leave your feedback': 'Leave your feedback',
    'Type your feedback here': 'Type your feedback here',

    'Select time range': 'Select time range',
    'Number of student who answered "How are you today?" on this date': 'Number of students who answered "How are you today?" on this date',
    'From creating confidence to goal setting, you’ll find a great range of skill-based surveys, programs, and journals here.':
        'From creating confidence to goal setting, you’ll find a great range of skill-based surveys, programs, and journals here.',
    'Track trends': 'Track Trends',

    'Content has been removed from trends': 'Content has been removed from trends',
    'In process': 'In process',
    'Report failed': 'Failed',
    'Download report as {{format}}': 'Download report as {{format}}',
    'Report is not available for download': 'Report is not available for download',
    'End date:': 'End date:',

    'Total response percentage': 'Total response percentage',
    'You are going to generate new password for this student?': 'You are going to generate new password for this student?',
    'New password has already been generated today for this user! Do you want to generate it again?':
        'New password has already been generated today for this user! Do you want to generate it again?',
    'New class': 'New class',
    'Day review': 'Day review',
    'Seen 6 days ago': 'Seen {{time}} ago',
    'Left 6 days ago': 'Left {{time}} ago',
    'Thank you for helping us to make Upstrive better.': 'Thank you for helping us to make Upstrive better.',

    month: 'month',
    months: 'months',
    hour: 'hour',
    hours: 'hours',
    minute: 'minute',
    minutes: 'minutes',
    seconds: 'seconds',

    'New password is generated': 'New password is generated',
    'Thank you!': 'Thank you!',
    'Tell us how we can improve Upstrive in the box below': 'Tell us how we can improve Upstrive in the box below',
    reasons: 'Reasons',
    'Reminder has been deleted!': 'Reminder has been deleted!',
    'Program has been deleted!': 'Program has been deleted!',
    'No reports have been created yet': 'No reports have been created yet',
    Grade: 'Grade',
    'Feedback date': 'Feedback date',
    "Student's feedback": "Student's feedback",
    "Student's comment": "Student's comments",
    Reasons: 'Reasons',
    "Teachers' action": "Teachers' action",
    'Number of students that left a comment combined with uncomfortable emotion': 'Number of students that left a comment combined with uncomfortable emotion',
    '7d': '7d',
    '1m': '1m',
    '3m': '3m',
    '1y': '1y',
    'Percentage of students that submitted an emotion this week': 'Percentage of students that submitted an emotion this week',
    'Write your personal notes here': 'Write your personal notes here',
    'Percentage of teachers in your group who have registered in Upstrive': 'Percentage of teachers in your group who have registered in Upstrive',
    'Percentage of students in your group who have registered in Upstrive': 'Percentage of students in your group who have registered in Upstrive',
    Registration: 'Registration',
    'General Engagement': 'General Engagement',
    'You must select at least one option': 'You must select at least one option!',

    On: 'On',
    Class: 'Class',
    Classes: 'Classes',
    SOS: 'SOS',
    'Template is updated': 'Template is updated',
    'Options must differ ': 'Options must differ ',
    'Options must differ': 'Options must differ',
    Open: 'Open',
    'Choose the answer': 'Choose the answer',
    'Not selected': 'Not selected',
    Reset: 'Reset',
    'What are 3 things that are a bit challenging at the moment?': 'What are 3 things that are a bit challenging at the moment?',
    'What’s just one thing you will do differently tomorrow?': 'What’s just one thing you will do differently tomorrow?',
    'all students': 'all students',
    'Can`t create student without create class': 'Can`t create student without create class',
    Analytics: 'Analytics',
    'Full Desktop version': 'Full Desktop version',
    'Full Mobile version': 'Full Mobile version',
    Gender: 'Gender',
    "Student's emotion": "Student's emotions",
    Frequency: 'Frequency',
    'Download students credentials': 'Download students credentials',
    studentsCredentialsNotAvailable: "Students credentials aren't available yet. Please contact support.",
    'Monitor student unease with this pre-set Sample Group': 'Monitor student unease with this pre-set Sample Group',
    Never: 'Never',
    Sometimes: 'Sometimes',
    Often: 'Often',
    Always: 'Always',
    "If you don't agree to Terms and Conditions you are not going to be allowed to use the app!":
        "If you don't agree to Terms and Conditions you are not going to be allowed to use the app!",
    Continue: 'Continue',
    'Take action': 'Take action',
    'Anonymous user': 'Anonymous user',
    'Review content': 'Review content',
    Decline: 'Decline',
    Accept: 'Accept',
    'Content has been approved': 'Content has been approved',
    'Content has been declined': 'Content has been declined',
    "You don't have any content to review": "You don't have any content to review",
    "You don't have any upcoming content": "You don't have any upcoming content",

    'Search for students': 'Search for students',
    Feeling: 'Feeling',
    'Last online': 'Last online',
    'No data found': 'No data found',
    'This element will be updated once enough app-activity has been recorded': 'This element will be updated once enough app-activity has been recorded',
    'Monitor Wellbeing': 'Monitor Wellbeing',
    'What u wish to do?': 'What would you like to do?',
    'Open Chat': 'Open Chat',
    'Assign Action': 'Assign Action',
    'Manage Student': 'Manage Student',
    'Comfortable emotions since school year start': 'Comfortable emotions since school year start',
    'Multiple Uncomfortable Emotions': 'Multiple Uncomfortable Emotions',
    'Student checking vs class average': 'Student checking vs class average',
    'Class Average': 'Class Average',
    'Same as class average': 'Same as class average',
    'Less than class average': 'Lower than class average',
    'More than class average': 'Higher than class average',
    'Student activities vs class average': 'Student activities vs class average',
    Completion: 'Completion',
    'Class average': 'Class average',
    'completed activities': 'completed activities',
    Comparison: 'Comparison',
    'Emotions logged': 'Emotions logged',
    'Class Average of Comfortable Emotions': 'Class Average of Comfortable Emotions',
    'Details on emotions': 'Details on emotions',
    'Reasons for Emotions': 'Reasons for Emotions',
    'Show More Reasons': 'Show More Reasons',
    'Show Less Reasons': 'Show Less Reasons',
    Alerts: 'Alerts',
    'Assigned Actions': 'Assigned Actions',
    'Assigned by': 'Assigned by',
    Message: 'Message',
    'Show More': 'Show More',
    'Show Less': 'Show Less',
    'Participation in Activities': 'Participation in Activities',
    "Check out John's responses to app activities": "Check out {{name}}'s responses to app activities",
    'Activities John has participated in': 'Activities {{name}} has participated in',
    'Check-ins': 'Check-ins',
    'Take Action': 'Take Action',
    'Average number of emotions submitted by student on daily basis': 'Average number of emotions submitted by student on daily basis',
    'Number of emotion submitted on each day': 'Number of emotion submitted on each day',

    'Search for activities': 'Search for activities',
    'Average participation rate': 'Average participation rate',
    'Check activity responses here': 'Check activity responses here:',
    Remind: 'Remind',
    Details: 'Details',
    'View Less': 'View Less',
    'View All': 'View All',
    'Student check-ins overview': 'Student Check-ins Overview',
    'Comfortable emotions': 'Comfortable emotions',
    'Uncomfortable emotions': 'Uncomfortable emotions',
    'Not assigned': 'Not assigned',
    'Assigned to me': 'Assigned to me',
    'Assigned to others': 'Assigned to others',
    Completed: 'Completed',
    'took an action': 'took an action',
    assigned: 'assigned',
    'with the following message': 'with the following message:',
    'Emotional Trends': 'Emotional Trends',

    'Export PDF': 'Export PDF',

    StudentWellbeingThisYear: 'Student wellbeing this school year',
    TotalEmotions: 'Total emotions logged',
    'Student Wellbeing Comparison': 'Student Wellbeing Comparison',
    comparison_to_average_year: 'Comparison to the {{customLabel}} average',
    comparison_to_average_class: 'Comparison to the class average',
    comparison_to_average_school: 'Comparison to the {{customLabel}} average',
    wellbeing_above_average_year: '{{name}} is {{percentage}}% above the {{customLabel}} average for wellbeing, great job!',
    wellbeing_above_average_class: '{{name}} is {{percentage}}% above the class average for wellbeing, great job!',
    wellbeing_above_average_school: '{{name}} is {{percentage}}% above the {{customLabel}} average for wellbeing, great job!',
    wellbeing_bellow_average_year: '{{name}} is {{percentage}}% below the {{customLabel}} average for wellbeing.',
    wellbeing_bellow_average_class: '{{name}} is {{percentage}}% below the class average for wellbeing.',
    wellbeing_bellow_average_school: '{{name}} is {{percentage}}% below the {{customLabel}} average for wellbeing.',
    'Emotional Wellbeing Factors': 'Emotional Wellbeing Factors',
    Assigned: 'Assigned',

    wellbeing_equal_average_year: '{{name}} has the same wellbeing percentage as the {{customLabel}} average.',
    wellbeing_equal_average_class: '{{name}} has the same wellbeing percentage as the class average.',
    wellbeing_equal_average_school: '{{name}} has the same wellbeing percentage as the {{customLabel}} average.',

    highestComfortableLabelMonth: 'The month of {{date}} had the highest level of comfortable emotions.',
    highestComfortableLabelWeek: 'The week of {{date}} had the highest level of comfortable emotions.',
    highestComfortableLabelDay: '{{date}} had the highest level of comfortable emotions.',

    highestUncomfortableLabelMonth: 'The month of {{date}} had the highest level of uncomfortable emotions.',
    highestUncomfortableLabelWeek: 'The week of {{date}} had the highest level of uncomfortable emotions.',
    highestUncomfortableLabelDay: '{{date}} had the highest level of uncomfortable emotions.',

    'This content is anonymous, so you won’t be able to see any responses': 'This content is anonymous, so you won’t be able to see any responses.',

    'Show less': 'Show less',
    'Show more': 'Show more',
    Complete: 'Complete',
    Status: 'Status',
    'View less': 'View less',
    'View all': 'View all',
    Reminded: 'Reminded',
    'Show less reasons': 'Show less reasons',
    'Show more reasons': 'Show more reasons',
    'Same number of check-ins this selected period compared to previous.': 'Same number of check-ins this selected period compared to previous.',
    'More check-ins this selected period compared to previous.': 'more check-ins this selected period compared to previous.',
    'Fewer check-ins this selected period compared to previous.': 'fewer check-ins this selected period compared to previous.',
    'Same number of comfortable emotions this selected period compared to previous': 'Same number of comfortable emotions this selected period compared to previous.',
    'More comfortable emotions this selected period compared to previous': 'more comfortable emotions this selected period compared to previous',
    'Fewer comfortable emotions this selected period compared to previous.': 'fewer comfortable emotions this selected period compared to previous.',

    'Search to see student analytics': 'Search to see student analytics',
    'Use this search to find a student for deeper and advanced analytics': 'Use this search to find a student or a class for deeper and advanced analytics',
    'This section displays the most common reasons behind the comfortable and uncomfortable emotions submitted by the student during the selected period':
        'This section displays the most common reasons behind the comfortable and uncomfortable emotions submitted by the student during the selected period',
    "This emotion shows student's last submitted mood check": "This emotion shows student's last submitted mood check",
    Logged: 'Logged',
    'This section displays alerts created for the student based on logged emotions or activities. You can view details, reasons, and the assigned status of each alert, and take or assign actions as needed.':
        'This section displays alerts created for the student based on logged emotions or activities. You can view details, reasons, and the assigned status of each alert, and take or assign actions as needed.',
    'This section displays all assigned actions based on the student’s activities. You can view the status of each assignment to see if any action has been taken.':
        'This section displays all assigned actions based on the student’s activities. You can view the status of each assignment to see if any action has been taken.',
    'This section provides an overview of the student’s check-ins for the selected period. It shows the total number of check-ins, the percentage breakdown of comfortable and uncomfortable emotions, and highlights changes compared to the previous period.':
        'This section provides an overview of the student’s check-ins for the selected period. It shows the total number of check-ins, the percentage breakdown of comfortable and uncomfortable emotions, and highlights changes compared to the previous period.',
    'This section shows trends in the student’s emotional check-ins over time. It highlights the percentage of comfortable and uncomfortable emotions, along with the time frame and number of check-ins. Key insights, such as the highest levels of comfortable and uncomfortable emotions, are displayed for better understanding.':
        'This section shows trends in the student’s emotional check-ins over time. It highlights the percentage of comfortable and uncomfortable emotions, along with the time frame and number of check-ins. Key insights, such as the highest levels of comfortable and uncomfortable emotions, are displayed for better understanding.',
    'This section displays the activities created for the student during the selected period. You can remind the student to complete activities or view detailed information about each activity.':
        'This section displays the activities created for the student during the selected period. You can remind the student to complete activities or view detailed information about each activity.',
    'This section provides an overview of the student’s logged emotions for the current school year. It highlights the total number of emotions recorded, along with the breakdown of comfortable and uncomfortable emotions as percentages.':
        'This section provides an overview of the student’s logged emotions for the current school year. It highlights the total number of emotions recorded, along with the breakdown of comfortable and uncomfortable emotions as percentages.',
    'This section compares the student’s wellbeing data to the class and year averages for the selected period. It highlights differences in percentages, showing how the student’s performance aligns with or deviates from their peers':
        'This section compares the student’s wellbeing data to the class and year averages for the selected period. It highlights differences in percentages, showing how the student’s performance aligns with or deviates from their peers',
    'Occurs every Monday until 01/01/2025': 'Occurs every {{day}} until {{date}}',

    //
    'Class wellbeing for this school year': 'Class wellbeing for this school year',
    'Class check-ins overview': 'Class Check-Ins Overview',
    'Class Wellbeing Comparison': 'Class Wellbeing Comparison',
    'School average': 'School average',
    'Class Emotional Trends': 'Class Emotional Trends',
    'Year 3 average': 'Year {{yearName}} average',
    'custom average': '{{customLabel}} average',
    'Class Emotional Wellbeing Factors': 'Class Emotional Wellbeing Factors',
    'John Doe has logged 3 uncomfortable emotions on': '{{first_name}} {{last_name}} has logged {{number}} unconfortable emotions on',
    'Class Engagement in Activities': 'Class Engagement in Activities',
    'Average class participation rate': 'Average class participation rate',
    'Check class activity responses here': 'Check class activity responses here:',
    'Class participation': 'Class participation',
    'Class Emotional Wellbeing by Student': 'Class Emotional Wellbeing by Student',
    'See all students': 'See all students',

    'Search for student or class analytics': 'Search for Student or Class Analytics',
    'Search for classes': 'Search for classes',
    'Search for': 'Search for',
    Students: 'Students',
    'Shows the total emotions logged by the class so far this year, with a simple breakdown into comfortable and uncomfortable emotions':
        'Shows the total emotions logged by the class so far this year, with a simple breakdown into comfortable and uncomfortable emotions.',
    'This section displays key factors impacting each student’s emotional wellbeing, with a breakdown of comfortable and uncomfortable emotions.':
        'This section displays key factors impacting each student’s emotional wellbeing, with a breakdown of comfortable and uncomfortable emotions.',
    'Show less students': 'Show less students',
    Student: 'Student',
    'Shows the class’s emotional check-ins for the selected period, with a breakdown of comfortable and uncomfortable emotions.':
        'Shows the class’s emotional check-ins for the selected period, with a breakdown of comfortable and uncomfortable emotions.',
    'Load More': 'Load More',
    'This section shows alerts for students who have logged 3 consecutive uncomfortable emotions. You can use these alerts to monitor your students’ emotional wellbeing and take necessary actions.':
        'This section shows alerts for students who have logged 3 consecutive uncomfortable emotions. You can use these alerts to monitor your students’ emotional wellbeing and take necessary actions.',
    'This section displays the average participation of the class in all activities over the selected period. Use this to monitor engagement and identify areas where students may need more support or encouragement':
        'This section displays the average participation of the class in all activities over the selected period. Use this to monitor engagement and identify areas where students may need more support or encouragement',
    'This section displays the factors contributing to the class’s comfortable and uncomfortable emotions. View the breakdown of each emotion type, along with the most common contributing factors for the selected period.':
        'This section displays the factors contributing to the class’s comfortable and uncomfortable emotions. View the breakdown of each emotion type, along with the most common contributing factors for the selected period.',

    'Class analytics': 'Class analytics',
    'Student analytics': 'Student analytics',
    'We found student(s)': 'We found {{total}} student(s)',
    'We found class(es)': 'We found {{total}} class(es)',

    'Number of class engagements': 'Number of class engagements',
    'Average class participation rate': 'Average class participation rate',
    'Number of surveys': 'Number of surveys',
    'Avg. participation rate': 'Avg. participation rate',
    'Number of polls': 'Number of polls',
    'Number of questions': 'Number of questions',
    'Your class': 'Your class',
    'We found 5 result(s) based on your search': 'We found {{total}} result(s) based on your search',
    'Classroom analytics': 'Classroom analytics',
    Loading: 'Loading',
    'No data to show based on your search': 'No data to show based on your search',

    'Skip guide': 'Skip guide',
    'Close guide': 'Close guide',
    'Next page': 'Next page',
    "Don't show again": "Don't show again",

    student_analytics_welcome: 'Welcome to the student analytics page. This tour will guide you seamlessly through each section of this feature.',
    student_analytics_student_info: 'This section displays key student details.',
    student_analytics_content: 'Here you can view insights about the student’s engagement and wellbeing.',
    student_analytics_personal_info: "The student's basic personal information is displayed here.",
    student_analytics_emotional_info: "The student's emotional trends over the past year are displayed here.",
    student_action_buttons: 'These four buttons allow you to take further steps to support the student.',
    student_analytics_filter: 'Use this filter to select a specific time span for analytics',
    student_analytics_checkins:
        "The student's check-in information is displayed here. You can review the student's emotional status based on comfortable and uncomfortable emotions.",
    student_analytics_wellbeing_comparison: "Here you can compare the student's wellbeing trends to their class or year group.",
    student_analytics_emotional_trends: "This graph displays the student's emotional patterns over time, based on the selected time frame chosen at the top of the page.",
    student_analytics_emotional_wellbeing_factors:
        "This section shows you the factors influencing the student's emotional state, divided into two sections. Click 'Show More Reasons' to view all reported comfortable and uncomfortable emotions.",
    student_analytics_alerts: 'Notifications appear here when a student reports an uncomfortable emotion. Click the button on the right for more details.',
    student_analytics_alerts_single_item:
        'Each alert includes the emotion, the factors behind it, and the date it was reported. Use the buttons at the bottom to take action or assign follow-up support.',
    student_analytics_assigned_actions:
        'This section displays all assigned actions for the student, including the status, who assigned it, who it was assigned to, the date, and any related messages.',
    student_analytics_participation: 'This section shows you all the activities the student has participated in.',
    student_analytics_participation_actions: 'Clicking on the Details button allows you to remind students about activities or display activity details.',

    class_analytics_welcome: 'Welcome to Class Analytics. This tour will guide you through each section.',
    class_analytics_class_info: 'This section displays key details about the class.',
    class_analytics_content: 'View overall class analytics and insights here.',
    class_analytics_info: 'The class information is shown here.',
    class_analytics_emotional_info: 'This displays emotional trends for the class over the past year.',
    class_analytics_filter: 'Use this filter to select a specific time span for analytics.',
    class_analytics_checkins: "Here you have a summary of the class's emotional check-ins, categorising emotions as comfortable or uncomfortable.",
    class_analytics_wellbeing_comparison: 'This compares the class’s wellbeing trends with yearly and school-wide averages.',
    class_analytics_emotional_trends: 'This graph displays the class’s emotional patterns over time, based on the selected time frame at the top of the page.',
    class_analytics_emotional_wellbeing_factors:
        "This shows the factors influencing the class’s emotional state, divided into two sections. Click 'Show More Reasons' to view all reported comfortable and uncomfortable emotions.",
    class_emotional_wellbeing_by_student: 'This section displays the comfortable and uncomfortable emotions of each student in the class for the selected time frame.',
    class_emotional_wellbeing_by_student_single: 'Click on a student’s entry to view their reported emotions and factors.',
    class_analytics_alerts: 'Notifications appear here when multiple students report uncomfortable emotions. Click the button on the right for more details.',
    class_analytics_alerts_single_item:
        'Each alert includes the emotion, the reason behind it, and the date it was reported. Use the buttons at the bottom to take action or assign follow-up support.',
    class_analytics_assigned_actions:
        'All assigned actions for the each student in the class are shown here. Each action has a status, who assigned it and to whom, date that it was assigned and a message from the assigner to the assignee.',
    class_analytics_participation: 'All activities that the students in the class participated in are shown here.',
    class_analytics_participation_actions: 'By clicking on these buttons, we can remind about activities or display activity details.',

    '2 years ago': '{{number}} {{period}} ago',
    '2 months ago': '{{number}} {{period}} ago',
    '2 days ago': '{{number}} {{period}} ago',
    'Year average': 'Year average',
    "This data compares your class's wellbeing to the average wellbeing of the year group and the school overall":
        "This data compares your class's wellbeing to the average wellbeing of the year group and the school overall.",
    "Here you'll see the class's emotional wellbeing over the selected period, showing the breakdown of comfortable and uncomfortable emotions":
        "Here you'll see the class's emotional wellbeing over the selected period, showing the breakdown of comfortable and uncomfortable emotions.",
    "Here you'll find actions that have been assigned to students, including their current status (Assigned or Completed). Track who assigned the action, when it was assigned, and any comments or updates related to the action.":
        "Here you'll find actions that have been assigned to students, including their current status (Assigned or Completed). Track who assigned the action, when it was assigned, and any comments or updates related to the action.",
    'has logged multiple uncomfortable emotions': 'has logged multiple uncomfortable emotions',

    'Browse All Classes': 'Browse All Classes',
    'Class not selected': 'Class not selected',
    'Click to move all to top': 'Click to move all to top',
    'Click “proceed” to get back to the class screen': 'Click “proceed” to get back to the class screen',
    Confirm: 'Confirm',
    'Does this best describe how you’re feeling right now,': 'Does this best describe how you’re feeling right now,',
    'Emotion successfully selected': 'Emotion successfully selected',
    'Emotions distribution': 'Emotions distribution',
    'Get Back': 'Get Back',
    'Get Deeper Insights': 'Get Deeper Insights',
    'It is needed to prevent students from entering teacher’s environment': 'It is needed to prevent students from entering teacher’s environment',
    'Main Dashboard': 'Main Dashboard',
    'My Classes': 'My Classes',
    'Open analytics': 'Open analytics',
    Selected: 'Selected',
    Proceed: 'Proceed',
    Profile: 'Profile',
    'Repeat security key': 'Repeat security key',
    'Repeat security key here': 'Repeat security key here',
    'Search Class': 'Search Class',
    "Secret keys don't match": "Secret keys don't match",
    'Setup your security key first': 'Set up your security key first',
    'Stay up to date with student support': 'Stay up to date with student support',
    'Enter your security key to access settings': 'Enter your security key to access settings',
    'Enter your security key to reset your answers': 'Enter your security key to reset your answers',
    'Enter your security key to switch from the child view to the teacher view': 'Enter your security key to switch from the child view to the teacher view.',
    'User Management': 'User Management',
    'Which image best describes how you’re feeling right now?': 'Which image best describes how you’re feeling right now?',
    'Wrong secret key': 'Wrong secret key',
    afraid: 'afraid',

    'Security Key': 'Security Key',
    'Security key is needed to switch from child environment to teacher environment': 'Security key is needed to switch from child environment to teacher environment',
    'Congrats!': 'Congrats!',
    'Security key has been set': 'Security key has been set',
    Logout: 'Logout',
    Settings: 'Settings',
    'Change Avatars': 'Change Avatars',
    'Go to Class Analytics': 'Go to Class Analytics',
    'Browse emotion distribution': 'Browse emotion distribution',
    Dashboard: 'Dashboard',
    Congratulations: 'Congratulations',
    'Everyone replied': 'Everyone replied',
    'No one replied yet': 'No one replied yet',
    //tutorialModal
    'Next Tutorial': 'Next Tutorial',
    'Previous Tutorial': 'Previous Tutorial',
    'Exciting New Analytics': 'Exciting New Analytics!',
    'New Student, Class and Grade Analytics': 'New Student, Class and Grade Analytics',
    'Better insights for you and your school': 'Better insights for you and your school.',
    'Now you can see how a student or class is doing compared to their own data, other classes, or the entire grade.':
        'Now you can see how a student or class is doing compared to their own data, other classes, or the entire grade.',
    'Student Wellbeing Details': 'Student Wellbeing Details',
    'Check-Ins Overview': 'Check-Ins Overview',
    'Less data, more information': 'Less data, more information :)',
    'See at a glance how often the student has checked in and the emotions they’ve logged.':
        'See at a glance how often the student has checked in and the emotions they’ve logged.',
    'Compare Students to Class': 'Compare Students to Class',
    'Get Deeper Insights': 'Get Deeper Insights',
    'Get everything you need to make informed decisions.': 'Get everything you need to make informed decisions.',
    'Quickly see how a student’s wellbeing compares to their class or year group.': 'Quickly see how a student’s wellbeing compares to their class or year group.',
    'Valuable Information': 'Valuable Information',
    'Powerful Wellbeing Analytics': 'Powerful Wellbeing Analytics',
    'Get everything you need to make more informed decisions.': 'Get everything you need to make more informed decisions.',
    'Dive deep into wellbeing data to spot trends and draw meaningful conclusions.': 'Dive deep into wellbeing data to spot trends and draw meaningful conclusions.',
    'Actionable Classroom Data': 'Actionable Classroom Data',
    'Explore Trends Across Classes and Grades': 'Explore Trends Across Classes and Grades',
    'Gain valuable insights into how your class is doing.': 'Gain valuable insights into how your class is doing.',
    'Uncover key wellbeing trends across classes and year groups.': 'Uncover key wellbeing trends across classes and year groups.',
    'Classroom Engagement': 'Classroom Engagement',
    'Track student engagement in Upstrive activities': 'Track student engagement in Upstrive activities',
    'How are they doing?': 'How are they doing?',
    'Get the insights you need to understand student engagement in Upstrive activities.': 'Get the insights you need to understand student engagement in Upstrive activities.',
    'Accessing Analytics': 's',
    'Search Smarter': 'Search Smarter',
    'Enter a student or class name to access the new Analytics. You can also view student-specific insights by clicking on a student in the Classroom section.':
        'Enter a student or class name to access the new Analytics. You can also view student-specific insights by clicking on a student in the Classroom section.',
    //tutorialModal
    'Open Student View': 'Open Student View',

    //notificationsSettings
    notificationSettings: 'Notifications settings',
    'Notifications settings': 'Notifications settings',
    push: 'Push',
    'In-App': 'In-App',
    Triggers: 'Triggers',
    pushNotifications: 'Push Notifications',
    'Here you can manage who will receive the push notifications for different types of alerts':
        'Here you can manage who will receive the push notifications for different types of alerts.',
    'Keyword alerts receipient(s) notifications': 'Keyword alerts recipient(s) notifications',
    'Uncomfortable emotions receipient(s) notifications': 'Uncomfortable emotions recipient(s) notifications',
    'In-app notifications': 'In-app notifications',
    'Here you can manage who will receive the in-app notifications for different types of alerts':
        'Here you can manage who will receive the in-app notifications for different types of alerts.',
    'Emotions to track': 'Emotions to track',
    'Number of emotions to trigger an alert': 'Number of emotions to trigger an alert',
    'Choose how many times a student must select an uncomfortable emotion before an alert is triggered, and select which emotions you want to track':
        'Choose how many times a student must select an uncomfortable emotion before an alert is triggered, and select which emotions you want to track.',
    'Uncomfortable emotions triggers': 'Uncomfortable Emotions Triggers',
    'in a row': 'in a row',
    'Email notifications': 'Email Notifications',
    'Here you can manage who will receive the email notifications for different types of alerts':
        'Here you can manage who will receive the email notifications for different types of alerts.',
    'Keyword alerts receipient(s) email': 'Keyword alerts recipient(s) email',
    'Uncomfortable emotions receipient(s) email': 'Uncomfortable emotions recipient(s) email',
    'Custom email': 'Custom email',
    'Press “ENTER” to save the word you want to add': 'Press “ENTER” to save the word you want to add',
    'No matching options': 'No matching options',
    //notificationsSettings
    'Open Upstrive Education': 'Open Upstrive Education',
    'Open Upstrive Early': 'Open Upstrive Early',
    //alerts section
    'All alerts': 'All alerts',
    'Keyword alerts': 'Keyword alerts',
    'Keyword Alert': 'Keyword Alert',
    'Help us improve': 'Help us improve',
    'How would you rate the accuracy of flagging this comment as a risk? From low (1) to high (5)':
        'How would you rate the accuracy of flagging this comment as a risk? From low (1) to high (5).',
    'Mark as false alert': 'Mark as false alert',
    'Thank you for helping us!': 'Thank you for helping us!',
    'Your feedback helps us improve our system for detecting keywords!': 'Your feedback helps us improve our system for detecting keywords!',
    "Don't show me this in the future": "Don't show me this in the future",
    'I Understand': 'I Understand',
    'AI-Powered Wellbeing Alerts – Important Notice': 'AI-Powered Wellbeing Alerts – Important Notice',
    //alerts section
    'included in their response': 'included in their response',
    'This entry was flagged by': 'This entry was flagged by {{name}}',

    'Scheduled Emails for this Upload': 'Scheduled Emails for this Upload',
    'Enter a descriptive label for this email': 'Enter a descriptive label for this email',
    "Based on school's timezone": "Based on school's timezone",
    'View All Scheduled': 'View All Scheduled',
    added: 'added',
    updated: 'updated',
    Staff: 'Staff',
    'User Type': 'User Type',
    Selection: 'Selection',
    'All users': 'All users',
    'New users only': 'New users only',

    Numbness: 'Numbness',
    Worry: 'Worry',
    Stress: 'Stress',
    Sadness: 'Sadness',
    Anger: 'Anger',
    Lethargy: 'Lethargy',
    Grumpiness: 'Grumpiness',
    'Feeling emotionally disconnected or unable to process emotions': 'Feeling emotionally disconnected or unable to process emotions.',
    'Feeling uneasy about something uncertain or future-related': 'Feeling uneasy about something uncertain or future-related.',
    'Feeling overwhelmed or pressured due to challenges, responsibilities, or expectations':
        'Feeling overwhelmed or pressured due to challenges, responsibilities, or expectations.',
    'A deep feeling of unhappiness or disappointment': 'A deep feeling of unhappiness or disappointment.',
    'A strong feeling of frustration or annoyance, often in response to something unfair or upsetting':
        'A strong feeling of frustration or annoyance, often in response to something unfair or upsetting.',
    'Feeling tired, drained, sluggish, or low in energy': 'Feeling tired, drained, sluggish, or low in energy.',
    'Feeling irritated or easily annoyed, sometimes without a clear reason': 'Feeling irritated or easily annoyed, sometimes without a clear reason.',
    'If needed, you can flag this comment': 'If needed, you can flag this comment',
    'Mark comment as risk': 'Mark comment as risk',
    'See alert': 'See alert',
    'This comment has not been marked as a risk, you can change that by clicking the button':
        'This comment has not been marked as a risk, you can change that by clicking the button.',
    'This entry was flagged by AI for': 'This entry was flagged by AI for [{{category}}]',

    violence: 'violence',
    'self harm': 'self harm',
    sexual: 'sexual',
    hate: 'hate',
    harassment: 'harassment',
    'sexual/minors': 'sexual/minors',
    'self-harm/intent': 'self-harm/intent',
    'Keyword settings': 'Keyword settings',

    'Start Journalling!': 'Start Journalling!',

    'Select who gets notified when a student selects uncomfortable emotions over multiple consecutive check-ins':
        'Select who gets notified when a student selects uncomfortable emotions over multiple consecutive check-ins.',
    'Choose who should receive emails when a student uses flagged keywords in their check-in comments':
        'Choose who should receive emails when a student uses flagged keywords in their check-in comments.',
    'Manage who receives email notifications for different types of alerts triggered by student check-ins':
        'Manage who receives email notifications for different types of alerts triggered by student check-ins.',
    'Select who should receive push notifications for flagged keywords and for multiple consecutive uncomfortable emotions logged':
        'Select who should receive push notifications for flagged keywords and for multiple consecutive uncomfortable emotions logged.',
    'Select who should receive push notifications when a student’s check-in includes flagged keywords':
        'Select who should receive push notifications when a student’s check-in includes flagged keywords.',
    'Select who should receive push notifications when students select uncomfortable emotions over multiple consecutive check-ins':
        'Select who should receive push notifications when students select uncomfortable emotions over multiple consecutive check-ins.',
    'Manage how many times uncomfortable emotions need to appear before triggering an alert, and choose which emotions to track':
        'Manage how many times uncomfortable emotions need to appear before triggering an alert, and choose which emotions to track.',
    'Select how many days in a row a student must log uncomfortable emotions before an alert is sent':
        'Select how many days in a row a student must log uncomfortable emotions before an alert is sent.',
    'Choose which specific uncomfortable emotions will be monitored for alerts': 'Choose which specific uncomfortable emotions will be monitored for alerts.',

    // counsellor analytics
    'School analytics': 'School analytics',
    'School average - emotions logged': 'School average - {{number}} emotions logged',
    Comfortable: 'Comfortable',
    'All classes': 'All classes',
    'See analytics': 'See analytics',
    'See Analytics': 'See Analytics',
    'Wellbeing comparison for selected student groups': 'Wellbeing comparison for selected student groups',
    average: 'average',
    'See Class Analytics': 'See Class Analytics',
    'Show less Years': 'Show less Years',
    'Show all Years': 'Show all Years',
    'Check-ins overview for selected student groups': 'Check-ins overview for selected student groups',
    'Emotional trends for selected student groups': 'Emotional trends for selected student groups',
    'Year 1 average': 'Year {{name}} average',
    'Counselor Emotional Wellbeing Factors': 'Emotional wellbeing factors for selected student groups',
    'Engagement in activities for selected student groups': 'Engagement in activities for selected student groups',
    'All Activities': 'All Activities',
    'Alerts for selected student groups': 'Alerts for selected student groups',
    'By number of alerts': 'By number of alerts',
    'By number of assigned alerts': 'By number of assigned alerts',
    'By number of unassigned alerts': 'By number of unassigned alerts',
    has: 'has',
    alerts: 'alerts',
    alert: 'alert',
    'Select all classes': 'Select all classes',
    content: 'Content',
    'By number of assigned': 'By number of assigned',
    'By number of unassigned': 'By number of unassigned',
    'Counsellor analytics': 'Counsellor analytics',
    'Demo text': 'Demo text',
    'Option 1': 'Option 1',
    'Option 2': 'Option 2',
    'See all years': 'See all years',
    unassigned: 'unassigned',
    'See less years': 'See less years',
    'Whole school': 'Whole school',
    visitOurWebsiteForMoreDetails: 'Visit our <white>website</white> for more details.',
    'Compare the wellbeing of different groups against the school average to spot trends and outliers.':
        'Compare the wellbeing of different groups against the school average to spot trends and outliers.',
    Counsellor: 'Counsellor',
    'This data shows the ratio of logged emotions from the start of the school year until today':
        'This data shows the ratio of logged emotions from the start of the school year until today',
    'More comfortable emotions logged during this period compared to the previous one.': 'More comfortable emotions logged during this period compared to the previous one.',
    'Overall balance of emotions logged since the start of the school year.': 'Overall balance of emotions logged since the start of the school year.',
    'Same number of check-ins recorded during this period compared to the previous one': 'Same number of check-ins recorded during this period compared to the previous one',
    'Same number of comfortable emotions logged during this period compared to the previous one.':
        'Same number of comfortable emotions logged during this period compared to the previous one.',
    'School-wide emotional breakdown based on number check-ins': 'School-wide emotional breakdown based on {{number}} check-ins',
    'Search All Analytics': 'Search All Analytics',
    'See how feeling factors are influencing students’ emotions.': 'See how feeling factors are influencing students’ emotions.',
    'Select which classes to include in the school-wide analytics view.': 'Select which classes to include in the school-wide analytics view.',
    'Track how selected groups are engaging with activities, programs, and content.': 'Track how selected groups are engaging with activities, programs, and content.',
    'Use this search to explore student, class, or counsellor analytics and access deeper insights.':
        'Use this search to explore student, class, or counsellor analytics and access deeper insights.',
    'View all keyword and emotion alerts for selected year groups.': 'View all keyword and emotion alerts for selected year groups.',
    'View check-in and emotion trends over time to spot changes in student engagement': 'View check-in and emotion trends over time to spot changes in student engagement',
    'View trends in comfortable and uncomfortable emotions to spot key patterns and peaks.':
        'View trends in comfortable and uncomfortable emotions to spot key patterns and peaks.',
    'fewer check-ins recorded during this period compared to the previous one': 'fewer check-ins recorded during this period compared to the previous one',
    'fewer comfortable emotions logged during this period compared to the previous one.': 'fewer comfortable emotions logged during this period compared to the previous one.',
    'more check-ins recorded during this period compared to the previous one': 'More check-ins recorded during this period compared to the previous one.',
    'Last email with password was sent': 'Last email with password was sent',

    // Organization analytics
    Organization: 'Organization',
    'Organization analytics': 'Organization analytics',
    'Emotions check-in frequency': 'Emotions check-in frequency',
    'All schools': 'All schools',
    'Organization average number': 'Organization average - {{number}} emotions logged',
    'Organization average': 'Organization average',
    school_average: '{{name}} average',
    'Select all schools': 'Select all schools',
    'Select which schools to include in the organization-wide analytics view.': 'Select which schools to include in the organization-wide analytics view.',
    '6 check-ins per student': '{{number}} check-ins per student',

    "I think I'm feeling this way because": "I think I'm feeling this way because...",
    'Nothing in Chat yet — new messages will appear here': 'Nothing in Chat yet — new messages will appear here.',
    'No responses yet — check back soon!': 'No responses yet — check back soon!',
    'Program successfully shared': 'Program successfully shared',

    //Upload engine words
    'School Data Upload': 'School Data Upload',
    'Upload Type': 'Upload Type',
    Type: 'Type',
    'Upload File': 'Upload File',
    Upload: 'Upload',
    'Preview & Submit': 'Preview & Submit',
    Preview: 'Preview',
    Pending: 'Pending',
    'In Progress': 'In Progress',
    Ready: 'Ready',
    'Choose Your Upload Method': 'Choose Your Upload Method',
    'Decide if you want a full reset for a new school year, or just add new users during the year.':
        'Decide if you want a full reset for a new school year, or just add new users during the year.',
    'Recommended for new school year': 'Recommended for new school year',
    'Gives you a clean slate for the year ahead': 'Gives you a clean slate for the year ahead',
    'Disables absent users': 'Disables absent users',
    'Removes unused classes': 'Removes unused classes',
    'Replaces all student & staff data with your new file': 'Replaces all student & staff data with your new file',
    'Use this option when starting a new school year or setting up your school on Upstrive for the first time.':
        'Use this option when starting a new school year or setting up your school on Upstrive for the first time.',
    'New School Year Setup': 'New School Year Setup',
    'Whole School Update': 'Whole School Update',

    'Recommended for mid-year updates': 'Recommended for mid-year updates',
    'Safe to use anytime during the year': 'Safe to use anytime during the year',
    'Creates classes if needed': 'Creates classes if needed',
    'Keeps existing accounts unchanged': 'Keeps existing accounts unchanged',
    'Adds only new users from your file': 'Adds only new users from your file',
    'Use this option to add students or staff during the school year while keeping everything else the same.':
        'Use this option to add students or staff during the school year while keeping everything else the same.',
    'Mid-Year Updates': 'Mid-Year Updates',
    'Add New Users': 'Add New Users',
    'Click to select': 'Click to select',

    'You want to remove inactive accounts': 'You want to remove inactive accounts',
    'You have complete, current data': 'You have complete, current data',
    'Starting a new academic year': 'Starting a new academic year',
    'Choose Whole School Update when': 'Choose Whole School Update when',
    'Quick Decision Guide': 'Quick Decision Guide',

    'You want to keep existing accounts': 'You want to keep existing accounts',
    'Your file only has new users': 'Your file only has new users',
    'Adding students during the year': 'Adding students during the year',
    'Choose Add New Users when': 'Choose Add New Users when',

    'Important: Data Replacement Warning': 'Important: Data Replacement Warning',
    'Updating will remove any accounts or classes not in your file. Double-check your file includes all current students and staff before continuing.':
        'Updating will remove any accounts or classes not in your file. Double-check your file includes all current students and staff before continuing.',
    'Safe Addition Mode': 'Safe Addition Mode',
    'Your existing data is protected. Only new users from the Excel file will be added to the system. No existing accounts will be modified or disabled.':
        'Your existing data is protected. Only new users from the Excel file will be added to the system. No existing accounts will be modified or disabled.',
    'Continue to File Upload': 'Continue to File Upload',
    'Select an upload method to continue': 'Select an upload method to continue',

    'File Processed Successfully!': 'File Processed Successfully!',
    'Your Excel file has been analyzed and is ready for import': 'Your Excel file has been analyzed and is ready for import',
    'Browse Files': 'Browse Files',
    'or click the button below to browse your files': 'or click the button below to browse your files',
    'Drag and drop your Excel file': 'Drag and drop your Excel file',
    'Drop your file here': 'Drop your file here',
    'Release to upload': 'Release to upload,',

    'File Requirements': 'File Requirements',
    'Supported Formats': 'Supported Formats',
    'Excel 2007+ (.xlsx)': 'Excel 2007+ (.xlsx)',
    'Excel 97-2003 (.xls)': 'Excel 97-2003 (.xls)',
    'File Structure': 'File Structure',
    'Must include headers': 'Must include headers',
    'Separate sheets for students/staff': 'Separate sheets for students/staff',

    'Processing Your File': 'Processing Your File',
    'Analyzing Excel data and preparing for import...': 'Analyzing Excel data and preparing for import...',
    Processing: 'Processing',
    'Processing progress': 'Processing progress',
    'Reading Excel': 'Reading Excel',
    'Analyzing Data': 'Analyzing Data',
    'Validating Records': 'Validating Records',

    "What's happening now?": "What's happening now?",
    'Reading and parsing your Excel file structure': 'Reading and parsing your Excel file structure',
    'Identifying student and staff data sheets': 'Identifying student and staff data sheets',
    'Validating data format and required fields': 'Validating data format and required fields',
    'Preparing data for import configuration': 'Preparing data for import configuration',

    'File Uploaded Successfully!': 'File Uploaded Successfully!',
    'Your Excel file has been processed and is ready for import': 'Your Excel file has been processed and is ready for import',
    'Continue to Settings': 'Continue to Settings',
    'Back to Upload Type': 'Back to Upload Type',
    'The following errors were found': 'The following errors were found',

    'Configure Import Settings': 'Configure Import Settings',
    'Selected Method': 'Selected Method',
    'Fine-tune how your data will be imported based on your selected upload method': 'Fine-tune how your data will be imported based on your selected upload method',
    Active: 'Active',
    'Data Replacement': 'Data Replacement',
    'Clear existing data before importing (required for whole school update)': 'Clear existing data before importing (required for whole school update)',
    'Keep existing data and only add new records (required for add-only mode)': 'Keep existing data and only add new records (required for add-only mode)',

    'Password Reset': 'Password Reset',
    'Force users to change their password on first login for enhanced security': 'Force users to change their password on first login for enhanced security',
    'Recommended for new users and security compliance': 'Recommended for new users and security compliance',

    'Use Excel Passwords': 'Use Excel Passwords',
    'Use password values from the Excel file if available, otherwise generate secure passwords':
        'Use password values from the Excel file if available, otherwise generate secure passwords',
    'Password columns detected': 'Password columns detected',
    'No password columns detected in uploaded data. Secure passwords will be auto-generated.':
        'No password columns detected in uploaded data. Secure passwords will be auto-generated.',

    'Save Passwords to Master list': 'Save Passwords to Master list',
    'Store passwords from Excel file in a secure master list for administrative purposes': 'Store passwords from Excel file in a secure master list for administrative purposes',
    'Passwords will be saved securely and can be accessed by administrators when needed': 'Passwords will be saved securely and can be accessed by administrators when needed',

    'Excel File Requirements': 'Excel File Requirements',
    'Student Data': 'Student Data',
    'Staff Data': 'Staff Data',

    'Student ID (required)': 'Student ID (required)',
    'Full Name (required)': 'Full Name (required)',
    'Class Assignment (required)': 'Class Assignment (required)',
    'Email (required for secondary)': 'Email (required for secondary)',
    'Gender (optional)': 'Gender (optional)',
    'Password (optional)': 'Password (optional)',

    'Staff ID (required)': 'Staff ID (required)',
    'Email (required)': 'Email (required)',
    'Authority/Role (required)': 'Authority/Role (required)',
    'Department (optional)': 'Department (optional)',

    'Full Update Requirements': 'Full Update Requirements',
    'Add-Only Requirements': 'Add-Only Requirements',
    'Your Excel file should contain ALL current students and staff. Missing users will be disabled.':
        'Your Excel file should contain ALL current students and staff. Missing users will be disabled.',
    'Your Excel file should only contain NEW students and staff to be added to the system.':
        'Your Excel file should only contain NEW students and staff to be added to the system.',

    'Back to Upload': 'Back to Upload',
    'Continue to Preview': 'Continue to Preview',
    //step 4
    'Review and Submit Your Data': 'Review and Submit Your Data',
    'Review the processed data before submitting to ensure everything looks correct': 'Review the processed data before submitting to ensure everything looks correct',
    'Upload Method': 'Upload Method',

    'Total Students': 'Total Students',
    'Valid Entries': 'Valid Entries',
    'Secondary Students': 'Secondary Students',
    'Primary Students': 'Primary Students',
    Teachers: 'Teachers',
    'Full Access': 'Full Access',
    'Total Staff': 'Total Staff',

    'Data Issues Must Be Resolved': 'Data Issues Must Be Resolved',
    'Please review and fix the issues in the detailed tabs below before submitting your data.':
        'Please review and fix the issues in the detailed tabs below before submitting your data.',
    'Data Ready for Import': 'Data Ready for Import',
    'All critical issues have been resolved. Your data is ready to be submitted.': 'All critical issues have been resolved. Your data is ready to be submitted.',

    'Data preview': 'Data preview',
    Summary: 'Summary',
    'Total Classes': 'Total Classes',
    across1YearGroup: 'Across {{count}} year group',
    across5YearGroups: 'Across {{count}} year groups',
    '% of students': '% of students',

    'Missing Class': 'Missing Class',
    'Duplicate IDs': 'Duplicate IDs',
    'Duplicate Emails': 'Duplicate Emails',
    'Missing Emails': 'Missing Emails',
    'Secondary students without email': 'Secondary students without email',
    'Missing Passwords (Warning)': 'Missing Passwords (Warning)',
    'Will be auto-generated': 'Will be auto-generated',

    'Class Changes': 'Class Changes',
    'Removed Classes': 'Removed Classes',
    'Renamed Classes': 'Renamed Classes',
    'Existing classes to be renamed': 'Existing classes to be renamed',
    'Existing Name': 'Existing Name',
    'New Name': 'New Name',
    'New Classes': 'New Classes',
    'New Classes to be Added': 'New Classes to be Added',
    'Classes to be Removed': 'Classes to be Removed',

    'Student Data Requirements': 'Student Data Requirements',
    'Student ID': 'Student ID',
    'Required for all students': 'Required for all students',
    'Full Name': 'Full Name',
    'Class Assignment': 'Class Assignment',
    'Student Type': 'Student Type',
    'Student Type: Default is Secondary. Mark as Primary only if explicitly required in the “Upstrive Early Access” column.':
        'Student Type: Default is Secondary. Mark as Primary only if explicitly required in the “{{columnName}}” column.',
    'All students treated as secondary (no early access column found)': 'All students treated as secondary (no early access column found)',
    'Secondary students: Required and must be unique': 'Secondary students: Required and must be unique',
    'Primary students: Optional': 'Primary students: Optional',
    'Email Address': 'Email Address',
    'Optional, but use standard values when provided': 'Optional, but use standard values when provided',
    'Required for all students (treated as secondary)': 'Required for all students (treated as secondary)',
    'Secondary students': 'Secondary students',
    'Primary students: Not required': 'Primary students: Not required',
    'Used from Excel when available': 'Used from Excel when available',
    'System-generated': 'System-generated',
    'Used from Excel when available for all students': 'Used from Excel when available for all students',
    'System-generated for all students': 'System-generated for all students',
    'Data Issues': 'Data Issues',
    Warnings: 'Warnings',

    'No "Upstrive Early access" column found. All students will be treated as secondary students.':
        'No "Upstrive Early access" column found. All students will be treated as secondary students.',
    Info: 'Info',
    Note: 'Note',
    'No password column found. All students will receive system-generated passwords.': 'No password column found. All students will receive system-generated passwords.',
    'Back to Settings': 'Back to Settings',
    'Update School Data': 'Update School Data',
    'Adding New Users...': 'Adding New Users...',
    'Updating School Data...': 'Updating School Data...',
    'Storing the Excel file, please wait...': 'Storing the Excel file, please wait...',
    'Excel File Not Stored': 'Excel File Not Stored',
    'Retry Upload': 'Retry Upload',
    'Could not store the Excel file. Please retry the upload before continuing.': 'Could not store the Excel file. Please retry the upload before continuing.',
    'School Data Upload Not Available': 'School Data Upload Not Available',
    'Your school data is synchronised automatically through your MIS integration, so no Excel upload is needed.':
        'Your school data is synchronised automatically through your MIS integration, so no Excel upload is needed.',
    'Back to Management': 'Back to Management',
    'Import Failed': 'Import Failed',
    'Upload Another File': 'Upload Another File',

    'Missing Student IDs': 'Missing Student IDs',
    'Missing Student Names': 'Missing Student Names',
    'Duplicate Email Addresses': 'Duplicate Email Addresses',
    'Duplicate Student IDs': 'Duplicate Student IDs',
    'Missing Class Assignment': 'Missing Class Assignment',
    'Missing Passwords': 'Missing Passwords',
    'Missing Email Addresses': 'Missing Email Addresses',
    'Valid Student Records': 'Valid Student Records',
    'Invalid Gender Data': 'Invalid Gender Data',
    'No students in this category': 'No students in this category',

    Issue: 'Issue',
    Secondary: 'Secondary',
    Required: 'Required',
    'Not required': 'Not required',
    'Not set': 'Not set',

    duplicateWithRecord: 'Duplicate with record #{{recordNumber}}',
    duplicateRecord: 'Duplicate record',
    missingClass: 'Missing class',
    missingNameData: 'Missing name data',
    missingId: 'Missing ID',
    invalidGender: 'Invalid gender',
    missingEmailSecondary: 'Missing email (required for secondary students)',
    missingPasswordSecondary: 'Missing password (for secondary students)',
    dataIssue: 'Data issue',

    records: 'records',
    showing2to5of12Results: 'Showing {{start}} to {{end}} of {{total}} results',

    headOfKeyStage: 'Head of Key Stage',
    fullAccess: 'Full Access',
    noClassAssignedAuthority: 'No Class Assigned Authority',
    unknownFormat: 'Unknown Format',
    missingPasswords: 'Missing Passwords',
    ofStaff: 'of staff',
    'Authority Issues': 'Authority Issues',
    markAsTeachers: 'Mark as Teachers',
    markUnknownFormatAsTeachers: 'Mark unknown format staff as teachers with no class assignment',
    markAllAsTeachers: 'Mark All as Teachers',
    id: 'ID',
    authority: 'Authority',
    scopeField: 'Scope Field',
    scope: 'Scope',
    issue: 'Issue',
    actions: 'Actions',
    admin: 'Admin',
    keyStage: 'Key Stage',
    none: 'None',
    unknown: 'Unknown',
    noClassAssigned: 'No Class Assigned',
    noScopeDefined: 'No scope defined',
    notSet: 'Not set',
    markAsTeacher: 'Mark as Teacher',
    'New Staff to be Added': 'New Staff to be Added',
    Name: 'Name',
    Email: 'Email',
    'Staff to be Removed': 'Staff to be Removed',
    'Staff Changes': 'Staff Changes',
    'New Staff': 'New Staff',
    'Removed Staff': 'Removed Staff',
    'Authority Types': 'Authority Types',
    Admin: 'Admin',
    'Full access to all students and staff data': 'Full access to all students and staff data',
    'Head of Key Stage': 'Head of Key Stage',
    'Manages Primary (Years 1-6 + Early Years) or Secondary (Years 7-13) sections': 'Manages Primary (Years 1-6 + Early Years) or Secondary (Years 7-13) sections',
    'Manages specific year groups (e.g., "Head of Year 1" or "ALL FS1")': 'Manages specific year groups (e.g., "Head of Year 1" or "ALL FS1")',
    Teacher: 'Teacher',
    'Assigned to specific classes (e.g., "FS1A, FS2B" or "Year 3")': 'Assigned to specific classes (e.g., "FS1A, FS2B" or "Year 3")',
    'No Class Assigned': 'No Class Assigned',
    'Teachers without specific class assignments (can be manually set)': 'Teachers without specific class assignments (can be manually set)',
    'Unknown Format': 'Unknown Format',
    'Authority value does not match expected patterns (can be marked as teachers)': 'Authority value does not match expected patterns (can be marked as teachers)',
    Password: 'Password',
    'Passwords from Excel sheet will be used for staff accounts': 'Passwords from Excel sheet will be used for staff accounts',
    'Password column detected but not enabled in settings': 'Password column detected but not enabled in settings',
    Warning: 'Warning',
    '"Set password from sheet" is enabled but no password column was found in the data.': '"Set password from sheet" is enabled but no password column was found in the data.',
    'Upload Successful!': 'Upload Successful!',
    'Existing users not in Excel will be disabled and old classes will be removed.': 'Existing users not in Excel will be disabled and old classes will be removed.',
    'Only new users will be added. Existing users and classes remain unchanged.': 'Only new users will be added. Existing users and classes remain unchanged.',
    'This will permanently remove users and classes not in your Excel file': 'This will permanently remove users and classes not in your Excel file',

    // Email Scheduling
    'Schedule email for new users': 'Schedule email for new users',
    'This tool helps you to schedule emails for users based on their timezone': 'This tool helps you to schedule emails for users based on their timezone',
    'Email will be sent on': 'Email will be sent on',
    "school's time": "school's time",
    'your time': 'your time',
    'school is in Europe/Zagreb': 'school is in Europe/Zagreb',
    'List of all scheduled emails with their details': 'List of all scheduled emails with their details',
    'Schedule Emails': 'Schedule Emails',
    'Email Scheduling': 'Email Scheduling',
    'Schedule Email': 'Schedule Email',
    'Scheduled Emails': 'Scheduled Emails',
    'Select Upload for Email Scheduling': 'Select Upload for Email Scheduling',
    'No previous uploads found': 'No previous uploads found',
    'Back to Uploads': 'Back to Uploads',
    'Selected Upload': 'Selected Upload',
    'User Selection': 'User Selection',
    'All Users': 'All Users',
    'New Users Only': 'New Users Only',
    'Set date': 'Set date',
    'Set time': 'Set time',
    'Set label': 'Set label',
    'Label (optional)': 'Label (optional)',
    'Email will be sent on': 'Email will be sent on',
    'View Scheduled': 'View Scheduled',
    'No scheduled emails found': 'No scheduled emails found',
    'Schedule New Email': 'Schedule New Email',
    'Scheduled for': 'Scheduled for',
    'Basic Information': 'Basic Information',
    'Task ID': 'Task ID',
    'Processing Results': 'Processing Results',
    'Primary Processed': 'Primary Processed',
    'Secondary Processed': 'Secondary Processed',

    'Number of check-ins on weekly basis in selected timeframe': 'Number of check-ins on weekly basis in selected timeframe',
    'Number of students': 'Number of students',
    'See all organizations': 'See all organizations',
    'See less organizations': 'See less organizations',
    'Select which schools to include in the organization-wide analytics view.': 'Select which schools to include in the organization-wide analytics view.',
    'Student Check-In Activity': 'Student Check-In Activity',
    'The average number of check-ins per student for the selected timeframe on weekly basis.':
        'The average number of check-ins per student for the selected timeframe on weekly basis.',
    'Year {{year}} average': 'Year {{year}} average',
    backToLogin: 'Back to Login',
    backToForgotPassword: 'Back to Forgot Password',
    'Run journal': 'Run journal',
    //more words
    'Preparing your data': 'Preparing your data',
    'Number of responses per day': 'Number of responses per day',
    'Number of responses': 'Number of responses',
    'Actions taken': 'Actions taken',
    "Teachers' actions": "Teachers' actions",
    'Times logged': 'Times logged',
    Added: 'Added',
    'Admin Created': 'Admin Created',
    'Animals Assigned': 'Animals Assigned',
    'Click to send an email with your current upload details': 'Click to send an email with your current upload details',
    Created: 'Created',
    'Created At': 'Created At',
    'Download Template': 'Download Template',
    'Download the Excel template to get started with the correct format': 'Download the Excel template to get started with the correct format',
    Error: 'Error',
    Errors: 'Errors',
    'File Information': 'File Information',
    'File Name': 'File Name',
    'File Size': 'File Size',
    'HOY Created': 'HOY Created',
    'Having Issues? Contact Support': 'Having Issues? Contact Support',
    ID: 'ID',
    'Import User Data': 'Import User Data',
    Issues: 'Issues',
    Label: 'Label',
    'Master List': 'Master List',
    'Master List Stats': 'Master List Stats',
    'Need Help? Contact Support': 'Need Help? Contact Support',
    'No Previous Uploads': 'No Previous Uploads',
    'No upload history found': 'No upload history found',
    'Number of critical issues': 'Number of critical issues',
    'Number of warnings': 'Number of warnings',
    Populated: 'Populated',
    'Previous Uploads': 'Previous Uploads',
    Processed: 'Processed',
    Progress: 'Progress',
    'Ready to process': 'Ready to process',
    'Remove File': 'Remove File',
    Retry: 'Retry',
    Schedule: 'Schedule',
    Select: 'Select',
    'Select an Excel file containing user information for bulk import': 'Select an Excel file containing user information for bulk import',
    'Target group': 'Target group',
    'Teachers Assigned': 'Teachers Assigned',
    'The following warnings were found': 'The following warnings were found',
    Updated: 'Updated',
    'Updated At': 'Updated At',
    'Upload Details': 'Upload Details',
    'Upload Another': 'Upload Another',
    'Write your personal notes here (only you can see this)': 'Write your personal notes here (only you can see this)',
    //more words
    'Describe how you will respond': 'Describe how you will respond',
    'Assign to': 'Assign to',

    Actions: 'Actions',
    'Additional Options': 'Additional Options',
    All: 'All',
    'Are you sure you want to delete this scheduled email?': 'Are you sure you want to delete this scheduled email?',
    'Delete scheduled email': 'Delete scheduled email',
    'Disable password prompt': 'Disable password prompt',
    'Turn off new password prompt at login': 'Turn off new password prompt at login',
    'Email scheduled successfully': 'Email scheduled successfully',
    'Error deleting scheduled email': 'Error deleting scheduled email',
    'Failed to delete scheduled email': 'Failed to delete scheduled email',
    'Manage your email schedule': 'Manage your email schedule',
    New: 'New',
    'No Scheduled Emails': 'No Scheduled Emails',
    'Save to master list': 'Save to master list',
    'Schedule Summary': 'Schedule Summary',
    'Scheduled Date': 'Scheduled Date',
    'Scheduled email deleted successfully': 'Scheduled emails deleted successfully',
    'Select Students': 'Select Students',
    'Select Teachers': 'Select Teachers',
    'Send emails to users based on timezone': 'Send emails to users based on timezone',
    Sent: 'Sent',
    'Set label (for internal use)': 'Set label (for internal use)',
    'Target Group': 'Target Group',
    'View scheduled emails': 'View scheduled emails',
    at: 'at',
    'Responding to': 'Responding to',
    'Need a template?': 'Need a template?',
    'Confirm Password': 'Confirm Password',
    'Re-enter your new password': 'Re-enter your new password',
    'Show all': 'Show all',
    //
    'Select Recipients': 'Select Recipients',
    'Select individual students or create a group to share this content with': 'Select individual students or create a group to share this content with',
    'Select specific year groups to share this content with': 'Select specific year groups to share this content with',
    'Select specific classes to share this content with': 'Select specific classes to share this content with',
    'Select staff members to share this content with': 'Select staff members to share this content with',

    'Do you want to pause the program?': 'Do you want to pause the program?',
    'Resume program': 'Resume program',
    stopProgram: 'Stop program',
    'Share your thoughts here': 'Share your thoughts here...',
    'This tool lets you manage your active programs': 'This tool lets you manage your active programs',
    'Refresher Videos': 'Refresher Videos',

    'Selecting role is required': 'Selecting role is required',
    'Hide login QR code': 'Hide login QR code',
    'Show login QR code': 'Show login QR code',
    'QR code hidden successfully': 'QR code hidden successfully',
    'Generate login QR code': 'Generate login QR code',

    'Comparison target': 'Comparison target',
    'Select class or year you want to compare your class to': 'Select class or year you want to compare your class to',

    'Content is not deleted': 'Content is not deleted',
    'Average number of responses daily': 'Average number of responses daily',
    'This content is visible to the following groups:': 'This content is visible to the following groups:',
    'Target preview': 'Target preview',
    'Number of teachers who answered "How are you today?" on this date': 'Number of teachers who answered "How are you today?" on this date',
    pulseCheck: 'Pulse Check',
    viewAs: 'View as',
    Overall: 'Overall',
    Emotional: 'Emotional',

    'Students feeling good': 'Students feeling good',

    Support: 'Support',

    'Students felt supported': 'Students felt supported',

    Coping: 'Coping',

    'Students coping well': 'Students coping well',

    Sleep: 'Sleep',

    'Students sleeping well': 'Students sleeping well',
    'vs last week': 'vs last week',
    'Trends Over Time': 'Trends Over Time',
    'Average response (1–5) by week': 'Average response (1–5) by week',
    'Latest vs Last Week': 'Latest vs Last Week',
    'Direction of change': 'Direction of change',
    Decline: 'Decline',
    Improvement: 'Improvement',
    'School Overview': 'School Overview',

    'Class Overview': 'Class Overview',

    'Heatmap of year-group averages': 'Heatmap of year-group averages',

    'Heatmap of student responses': 'Heatmap of student responses',

    'Avg 1–5 per pulse run': 'Avg 1–5 per pulse run',
    'Very High': 'Very High',

    High: 'High',

    Moderate: 'Moderate',

    Low: 'Low',

    'Very Low': 'Very Low',
    'Needs Attention': 'Needs Attention',

    'Students with low or declining pulse': 'Students with low or declining pulse',

    'At risk': 'At risk',

    Declining: 'Declining',

    Watch: 'Watch',

    'vs start': 'vs start',

    'View profile': 'View profile',

    'Open student list': 'Open student list',
    "Data is anonymised when viewed at group level and follows your school's privacy settings.":
        "Data is anonymised when viewed at group level and follows your school's privacy settings.",
    'Student list': 'Student list',

    All: 'All',

    'At risk': 'At risk',

    Declining: 'Declining',

    Watch: 'Watch',

    Stable: 'Stable',

    'Lowest score first': 'Lowest score first',

    'Biggest decline first': 'Biggest decline first',

    'Name A→Z': 'Name A→Z',

    'Highest score first': 'Highest score first',

    Target: 'Target',

    'All students': 'All students',

    'Pulse Check (last 8 weeks)': 'Pulse Check (last 8 weeks)',

    selected: 'selected',

    'header actions apply to selection': 'header actions apply to selection',

    Clear: 'Clear',

    'No students match this filter.': 'No students match this filter.',
    "Everyone's engaged 🎉": "Everyone's engaged 🎉",
    'Adjust inactivity settings': 'Adjust inactivity settings',
    "School holidays in this period don't count toward inactivity.": "School holidays in this period don't count toward inactivity.",
    "{{n}} students who have never engaged aren't shown — your inactivity settings exclude them.":
        "{{n}} students who have never engaged aren't shown — your inactivity settings exclude them.",
    'No classes assigned to you': 'No classes assigned to you',
    "Inactivity only covers students in the classes or years you're responsible for. Once your school admin assigns you some, they'll show up here.":
        "Inactivity only covers students in the classes or years you're responsible for. Once your school admin assigns you some, they'll show up here.",
    'No students yet': 'No students yet',
    'There are no student accounts in your classes yet. Once students are added, anyone who goes quiet will show up here.':
        'There are no student accounts in your classes yet. Once students are added, anyone who goes quiet will show up here.',
    'No one has engaged yet': 'No one has engaged yet',
    "{{n}} students joined in the past {{days}} days and haven't checked in or responded yet. Students only count as inactive after {{days}} quiet days, so they'll appear here if they stay quiet.":
        "{{n}} students joined in the past {{days}} days and haven't checked in or responded yet. Students only count as inactive after {{days}} quiet days, so they'll appear here if they stay quiet.",
    'No recently lapsed students': 'No recently lapsed students',
    '{{engaged}} of {{total}} students checked in or responded in the past {{days}} days.': '{{engaged}} of {{total}} students checked in or responded in the past {{days}} days.',
    '{{engaged}} of {{total}} students active': '{{engaged}} of {{total}} students active',
    "{{n}} new students haven't engaged yet": "{{n}} new students haven't engaged yet",
    "Couldn't load inactivity data": "Couldn't load inactivity data",
    'Something went wrong while checking student engagement. Please try again.': 'Something went wrong while checking student engagement. Please try again.',
    'Try again': 'Try again',
    'No student has gone {{days}} days without logging an emotion or responding to a check-in. Nothing needs your attention at this threshold.':
        'No student has gone {{days}} days without logging an emotion or responding to a check-in. Nothing needs your attention at this threshold.',
    '1 student quiet for {{days}}+ days': '1 student quiet for {{days}}+ days',
    '{{n}} students quiet for {{days}}+ days': '{{n}} students quiet for {{days}}+ days',
    'No one quiet for {{days}}+ days': 'No one quiet for {{days}}+ days',

    '3-week avg': '3-week avg',
    'Assign action': 'Assign action',

    'Export CSV': 'Export CSV',

    'Flag selection': 'Flag selection',
    Showing: 'Showing',
    'No targets found': 'No targets found',
    // Student Inactivity Alerts
    Inactivity: 'Inactivity',
    'Inactive students': 'Inactive students',
    'Download CSV': 'Download CSV',
    'Exporting...': 'Exporting...',
    'Failed to export': 'Failed to export',
    'Last login': 'Last login',
    'Never engaged': 'Never engaged',
    Lapsed: 'Lapsed',
    'Show more': 'Show more',
    'Inactivity threshold': 'Inactivity threshold',
    'Flag students who have not been active within this many days.': 'Flag students who have not been active within this many days.',
    'A student counts as active when they log an emotion or respond to a journal, poll, survey or question. Logging in on its own does not count.':
        'A student counts as active when they log an emotion or respond to a journal, poll, survey or question. Logging in on its own does not count.',
    'Include students who have never engaged': 'Include students who have never engaged',
    'School holidays': 'School holidays',
    'The inactivity counter pauses during these dates to avoid false alerts at the start of term.':
        'The inactivity counter pauses during these dates to avoid false alerts at the start of term.',
    'Label (optional)': 'Label (optional)',
    'Enter a valid start date with a four-digit year.': 'Enter a valid start date with a four-digit year.',
    'Enter a valid end date with a four-digit year.': 'Enter a valid end date with a four-digit year.',
    'Start date cannot be after end date.': 'Start date cannot be after end date.',
    'Choose who is notified about inactive students, per channel.': 'Choose who is notified about inactive students, per channel.',
    'In-app': 'In-app',
    'Custom email recipients': 'Custom email recipients',
    'Email digest frequency': 'Email digest frequency',
    'How often the inactivity report email is sent.': 'How often the inactivity report email is sent.',
    'Student check-in reminder': 'Student check-in reminder',
    'Show a reminder to students who have not checked in recently.': 'Show a reminder to students who have not checked in recently.',
    'Enable check-in reminder': 'Enable check-in reminder',
    'Remind after (days without a check-in)': 'Remind after (days without a check-in)',
    'Failed to save settings': 'Failed to save settings',
    off: 'Off',
    daily: 'Daily',
    weekly: 'Weekly',
    monthly: 'Monthly',

    chatStatsButton: 'Stats',
    chatStatsTitle: 'Student Chat Activity',
    chatStatsSubtitle: 'Chats initiated by students · outreach & help-seeking',
    chatStatsLoading: 'Loading…',
    chatStatsError: 'Could not load chat statistics',
    chatStatsRange7Days: '7 days',
    chatStatsRange30Days: '30 days',
    chatStatsRangeThisYear: 'This year',
    chatStatsRangeCustom: 'Custom',
    chatStatsAllClasses: 'All classes',
    chatStatsTypeLabel: 'Type:',
    chatStatsTypeTeacher: 'Teacher',
    chatStatsTypeCounsellor: 'Counsellor',
    chatStatsTypeSos: 'SOS',
    chatStatsClassOption: 'Year {{year}} · {{name}}',
    chatStatsSection1: 'How much is Chat being used?',
    chatStatsStudentsInitiated: 'Students who initiated chats',
    chatStatsOfStudents: 'of {{total}} · {{percent}}',
    chatStatsTotalChats: 'Total chats initiated',
    chatStatsVsPrevious: 'vs {{count}} previous period',
    chatStatsAvgPerStudent: 'Avg. chats per student',
    chatStatsChatsEach: 'chats each',
    chatStatsPerDay: '{{count}} chats initiated per day',
    chatStatsByType: 'Chats by Type',
    chatStatsDaysBadge: '{{count}} days',
    chatStatsInsightMoreChats: 'more chats initiated than the previous period, which suggests students are more willing to reach out.',
    chatStatsInsightFewerChats: 'fewer chats initiated than the previous period — worth checking how visible Chat is to students.',
    chatStatsInsightMoreSos: 'more SOS chats than the previous period. That can mean growing trust in the feature, or more students in difficulty.',
    chatStatsInsightFewerSos: 'fewer SOS chats than the previous period.',
    chatStatsSection2: 'Is the school responding quickly enough?',
    chatStatsResponsiveness: 'Responsiveness',
    chatStatsWithin24h: 'of chats responded to within 24 hours',
    chatStatsAvgFirstResponse: 'Average First Response',
    chatStatsAvgSosResponse: 'Average SOS Response',
    chatStatsWasLastPeriod: 'was {{value}} last period',
    chatStatsNoPreviousPeriod: 'no previous period',
    chatStatsPriorityTier: 'priority tier',
    chatStatsAnsweredLate: '{{count}} answered after more than 7 days, left out of the averages.',
    chatStatsSection3: 'What needs attention right now?',
    chatStatsNeedsAttention: 'Needs Attention Now',
    chatStatsAwaiting: 'Awaiting first response',
    chatStatsOverdue: 'Overdue > 24 hours',
    chatStatsStaffOutstanding: 'Staff with outstanding chats',
    chatStatsNothingWaiting: 'Nothing is waiting for a reply.',
    chatStatsOverdueBadge: '{{count}} overdue',
    chatStatsUnknownUser: 'Unknown user',
    chatStatsByClass: 'Chats by Class / Year',
    chatStatsNoClassInfo: 'No class information for the chats in this period.',
    chatStatsUnnamedClass: 'Unnamed class',
    chatStatsEmptyTitle: 'No chats initiated in this period',
    chatStatsEmptyBody:
        'No student started a Teacher, Counsellor or SOS chat in the selected time frame. Try widening the date range, or check that Chat is enabled for these classes.',
    chatStatsSearchClasses: 'Search classes…',
    chatStatsNoMatchingClasses: 'No matching classes',
    pinnedPosts: 'Pinned posts',
    pinned: 'Pinned',
    pinPost: 'Pin post',
    unpin: 'Unpin',
    pinnedBy: 'Pinned by',
    pinnedOn: 'Pinned on',
    pinnedPostsOverviewHelp: 'Pinned posts visible to your students. Only administrators can manage them.',
    noPinnedPosts: 'There are no pinned posts.',
    unavailablePinnedPost: 'Unavailable pinned post',
    postUnavailable: 'Post unavailable',
    postPinned: 'Post pinned',
    postUnpinned: 'Post unpinned',
    pinnedPostDeleteRestricted: 'Pinned posts must be unpinned by an administrator before they can be deleted.',
    pinPostFailed: 'The post could not be pinned',
    unpinPostFailed: 'The post could not be unpinned',
    confirmUnpinPost: 'Unpin this post?',
    manyPinnedPostsWarning: '{{count}} students would have {{total}} active pinned posts. Pin it anyway?',
    confirmPinPost: 'Pin this post?',
    pinPostConfirmationHelp: 'This post will appear in the pinned section for every student in its current audience.',
    unpinPostConfirmationHelp: 'Students will no longer see this post in their pinned section. The regular feed post will remain.',
    highVolumePinConfirmationHelp: 'This audience already has several active pinned posts. Confirm that this one is important enough to add.',
    recipients: 'Recipients',
    orSignInWith: 'or continue with',
    signInWithMicrosoft: 'Microsoft',
    signInWithGoogle: 'Google',
    ssoSigningIn: 'Signing you in...',
    ssoErrorNotEnabled: 'Sign-in with a school account is not enabled for your school. Please log in with your email and password.',
    ssoErrorAccountNotFound: 'We could not find an Upstrive account for this school account. Please contact your school administrator.',
    ssoErrorDuplicateAccounts: 'There are two accounts with this email. Please contact your school administrator.',
    ssoErrorPersonalAccount: 'Please use your school account, not a personal account.',
    ssoErrorUserDisabled: 'Your account is disabled. Please contact your school administrator.',
    ssoErrorTenantMismatch: 'This school account does not match the one on file for your school. Please contact your school administrator.',
    ssoErrorUnverifiedEmail: 'We could not verify your school account yet. Please contact your school administrator.',
    ssoErrorItAccessWebOnly: 'This account can only sign in on the Upstrive Education website, not in this app.',
    ssoErrorCancelled: 'Sign-in was cancelled.',
    ssoErrorGeneric: 'Sign-in with your school account failed. Please try again.',
    // Sidebar navigation
    mainNavigation: 'Main navigation',
    collapseSidebar: 'Collapse sidebar',
    expandSidebar: 'Expand sidebar',
    'Upstrive Early': 'Upstrive Early',
    'Tap a student to change their emotion': 'Tap a student to change their emotion',
    'Why do you feel this way? (optional)': 'Why do you feel this way? (optional)',
    'Could not save the emotion. Please try again.': 'Could not save the emotion. Please try again.',
    managementLoginBasisNote: 'Excludes Upstrive Early students, who do not sign in individually',
    managementLoggedInTooltip: '{{n}} of {{total}} have signed in at least once',
    managementNotLoggedInTooltip: '{{n}} of {{total}} have never signed in',
    managementPrimaryTooltip: '{{n}} Upstrive Early student(s). They sign in on a shared class device, so they have no individual login.',

    // Error boundary / recovery from a failed screen load
    errorBoundaryTitle: 'Something went wrong',
    errorBoundaryMessage: 'This screen could not be loaded. Reloading the page usually fixes it.',
    errorBoundaryOutdatedMessage: 'A newer version of Upstrive has been released. Reload the page to continue.',
    errorBoundaryReload: 'Reload page',
    imageCouldNotBeLoaded: 'This image could not be loaded.',
    connectionOffline: 'You\'re offline. Some things won\'t work until your connection is back.',
    connectionRestored: 'You\'re back online.',
}
export default TRANSLATION_EN
